{
  "about.blocks": "Модерируемые серверы",
  "about.contact": "Связаться:",
  "about.default_locale": "по умолчанию",
  "about.disclaimer": "Mastodon — свободное программное обеспечение с открытым исходным кодом и торговая марка Mastodon GmbH.",
  "about.domain_blocks.no_reason_available": "Причина не указана",
  "about.domain_blocks.preamble": "Обычно Mastodon даёт вам возможность просматривать содержимое с любых других серверов в федивёрсе и взаимодействовать с их пользователями. Вот исключения, сделанные конкретно для этого сервера:",
  "about.domain_blocks.silenced.explanation": "Как правило, вы не увидите профили и содержимое с этого сервера, если только вы не запросите их с помощью поиска или не подпишетесь на пользователя с этого сервера.",
  "about.domain_blocks.silenced.title": "Ограничивается",
  "about.domain_blocks.suspended.explanation": "Никакие данные с этого сервера не будут обрабатываться, храниться и обмениваться, что делает невозможным любое взаимодействие и связь с пользователями на этом сервере.",
  "about.domain_blocks.suspended.title": "Заблокирован",
  "about.language_label": "Язык",
  "about.not_available": "Администраторы сервера предпочли не раскрывать эту информацию.",
  "about.powered_by": "Децентрализованная социальная сеть на базе {mastodon}",
  "about.rules": "Правила сервера",
  "account.account_note_header": "Заметка для себя",
  "account.activity": "Посты",
  "account.add_note": "Добавить заметку для себя",
  "account.add_or_remove_from_list": "Добавить в списки",
  "account.badges.admin": "Администратор",
  "account.badges.blocked": "Заблокирован(а)",
  "account.badges.bot": "Бот",
  "account.badges.domain_blocked": "Домен заблокирован:",
  "account.badges.group": "Группа",
  "account.badges.muted": "Игнорируется",
  "account.badges.muted_until": "Игнорируется до {until}",
  "account.block": "Заблокировать @{name}",
  "account.block_domain": "Заблокировать {domain}",
  "account.block_short": "Заблокировать",
  "account.blocked": "Заблокирован(а)",
  "account.cancel_follow_request": "Отозвать запрос на подписку",
  "account.copy": "Копировать ссылку на профиль",
  "account.direct": "Упомянуть @{name} лично",
  "account.disable_notifications": "Не уведомлять о постах пользователя @{name}",
  "account.edit_note": "Редактировать заметку для себя",
  "account.edit_profile": "Редактировать",
  "account.edit_profile_short": "Редактировать",
  "account.enable_notifications": "Уведомлять о постах пользователя @{name}",
  "account.endorse": "Рекомендовать в профиле",
  "account.familiar_followers_many": "В подписках у {name1}, {name2}, и ещё {othersCount, plural, one {# человека, которого вы знаете} other {# человек, которых вы знаете}}",
  "account.familiar_followers_one": "В подписках у {name1}",
  "account.familiar_followers_two": "В подписках у {name1} и {name2}",
  "account.featured": "Рекомендации",
  "account.featured.accounts": "Профили",
  "account.featured.collections": "Подборки",
  "account.featured.new_collection": "Создать подборку",
  "account.field_overflow": "Показать полностью",
  "account.filters.all": "Всё вместе",
  "account.filters.boosts_toggle": "Показывать продвижения",
  "account.filters.posts_boosts": "Посты и продвижения",
  "account.filters.posts_only": "Только посты",
  "account.filters.posts_replies": "Посты и ответы",
  "account.filters.replies_toggle": "Показывать ответы",
  "account.follow": "Подписаться",
  "account.follow_back": "Подписаться в ответ",
  "account.follow_back_short": "Подписаться",
  "account.follow_request": "Отправить запрос на подписку",
  "account.follow_request_cancel": "Отозвать запрос",
  "account.follow_request_cancel_short": "Отозвать",
  "account.follow_request_short": "Отправить запрос",
  "account.followers": "Подписчики",
  "account.followers.empty": "На этого пользователя пока никто не подписан.",
  "account.followers_counter": "{count, plural, one {{counter} подписчик} few {{counter} подписчика} other {{counter} подписчиков}}",
  "account.followers_you_know_counter": "{count, plural, one {{counter} ваш знакомый} other {{counter} ваших знакомых}}",
  "account.following": "Подписки",
  "account.following_counter": "{count, plural, one {{counter} подписка} few {{counter} подписки} many {{counter} подписок} other {{counter} подписок}}",
  "account.follows.empty": "Этот пользователь пока ни на кого не подписался.",
  "account.follows_you": "Подписан(а) на вас",
  "account.go_to_profile": "Перейти к профилю",
  "account.hide_reblogs": "Скрыть продвижения от @{name}",
  "account.in_memoriam": "In Memoriam.",
  "account.join_modal.day": "День",
  "account.join_modal.me": "Вы зарегистрировались на сервере {server}",
  "account.join_modal.me_anniversary": "С годовщиной! Вы зарегистрировались на сервере {server}",
  "account.join_modal.me_today": "Сегодня ваш первый день на сервере {server}!",
  "account.join_modal.other": "{name} зарегистрировался (-лась) на сервере {server}",
  "account.join_modal.other_today": "Сегодня {name} отмечает первый день на сервере {server}!",
  "account.join_modal.share.celebrate": "Написать праздничный пост",
  "account.join_modal.share.intro": "Написать приветственный пост",
  "account.join_modal.share.welcome": "Написать приветственный пост",
  "account.join_modal.years": "{number, plural, one {год} few {года} many {лет} other {года}}",
  "account.joined_short": "Дата регистрации",
  "account.languages": "Изменить языки подписки",
  "account.last_active": "Последняя активность",
  "account.link_verified_on": "Владение этой ссылкой было проверено {date}",
  "account.locked_info": "Это закрытая учётная запись. Её владелец вручную одобряет подписчиков.",
  "account.media": "Медиа",
  "account.mention": "Упомянуть @{name}",
  "account.menu.add_to_collection": "Добавить в подборку…",
  "account.menu.add_to_list": "Добавить в список…",
  "account.menu.block": "Заблокировать",
  "account.menu.block_domain": "Заблокировать {domain}",
  "account.menu.copied": "Ссылка на профиль скопирована в буфер обмена",
  "account.menu.copy": "Копировать ссылку",
  "account.menu.direct": "Упомянуть лично",
  "account.menu.hide_reblogs": "Скрыть продвижения",
  "account.menu.mention": "Упомянуть",
  "account.menu.mute": "Игнорировать",
  "account.menu.note.description": "Не видно никому, кроме вас",
  "account.menu.open_original_page": "Открыть на {domain}",
  "account.menu.remove_follower": "Убрать из подписчиков",
  "account.menu.report": "Пожаловаться",
  "account.menu.share": "Поделиться…",
  "account.menu.show_reblogs": "Показывать продвижения",
  "account.menu.unblock": "Разблокировать",
  "account.menu.unblock_domain": "Разблокировать {domain}",
  "account.menu.unmute": "Не игнорировать",
  "account.moved_to": "У {name} теперь новая учётная запись:",
  "account.mute": "Игнорировать @{name}",
  "account.mute_notifications_short": "Скрыть уведомления",
  "account.mute_short": "Игнорировать",
  "account.muted": "Игнорируется",
  "account.mutual": "Вы подписаны друг на друга",
  "account.name.copy": "Копировать адрес",
  "account.name.help.domain": "{domain} — это сервер, на котором размещены профиль и посты пользователя.",
  "account.name.help.domain_self": "{domain} — это ваш сервер, на котором размещены ваши профиль и посты.",
  "account.name.help.footer": "Точно так же как вы отправляете сообщения пользователям разных почтовых сервисов, вы можете взаимодействовать с пользователями других серверов Mastodon и других платформ в сети Fediverse.",
  "account.name.help.header": "Адрес пользователя напоминает адрес электронной почты",
  "account.name.help.username": "{username} — это имя пользователя на сервере. На разных серверах могут встречаться люди с тем же именем пользователя.",
  "account.name.help.username_self": "{username} — это ваше имя пользователя на этом сервере. На других серверах могут встречаться люди с тем же именем пользователя.",
  "account.name_info": "Что это значит?",
  "account.no_bio": "Описание профиля отсутствует.",
  "account.node_modal.callout": "Эта заметка будет видна только вам.",
  "account.node_modal.edit_title": "Редактировать заметку для себя",
  "account.node_modal.error_unknown": "Не удалось сохранить заметку",
  "account.node_modal.field_label": "Текст заметки",
  "account.node_modal.save": "Сохранить",
  "account.node_modal.title": "Добавить заметку для себя",
  "account.note.edit_button": "Редактировать",
  "account.note.title": "Заметка для себя (никто, кроме вас, её не видит)",
  "account.open_original_page": "Открыть исходную страницу",
  "account.pending": "Не подтверждён",
  "account.posts": "Посты",
  "account.remove_from_followers": "Убрать {name} из подписчиков",
  "account.report": "Пожаловаться на @{name}",
  "account.requested_follow": "{name} отправил(а) вам запрос на подписку",
  "account.share": "Поделиться профилем @{name}",
  "account.show_reblogs": "Показывать продвижения от @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} пост} few {{counter} поста} other {{counter} постов}}",
  "account.timeline.pinned": "Закреплён",
  "account.timeline.pinned.view_all": "Показать все закреплённые посты",
  "account.unblock": "Разблокировать @{name}",
  "account.unblock_domain": "Разблокировать {domain}",
  "account.unblock_domain_short": "Разблокировать",
  "account.unblock_short": "Разблокировать",
  "account.unendorse": "Не рекомендовать в профиле",
  "account.unfollow": "Отписаться",
  "account.unmute": "Не игнорировать @{name}",
  "account.unmute_notifications_short": "Показать уведомления",
  "account.unmute_short": "Не игнорировать",
  "account_edit.advanced_settings.bot_hint": "Индикатор бота показывает, что с этой учётной записи выполняются автоматизированные действия и она не всегда может находиться под наблюдением владельца",
  "account_edit.advanced_settings.bot_label": "Учётная запись бота",
  "account_edit.advanced_settings.title": "Продвинутые настройки",
  "account_edit.bio.add_label": "Добавить описание профиля",
  "account_edit.bio.edit_label": "Редактировать описание профиля",
  "account_edit.bio.placeholder": "Добавьте немного информации о себе, чтобы другие люди могли легче узнать вас.",
  "account_edit.bio.title": "О себе",
  "account_edit.bio_modal.add_title": "Добавить описание профиля",
  "account_edit.bio_modal.edit_title": "Редактировать описание профиля",
  "account_edit.column_button": "Готово",
  "account_edit.column_title": "Редактировать профиль",
  "account_edit.custom_fields.add_label": "Создать поле профиля",
  "account_edit.custom_fields.edit_label": "Редактировать поле профиля",
  "account_edit.custom_fields.placeholder": "Добавьте свои местоимения, ссылки на сайты — всё, что посчитаете нужным указать в профиле.",
  "account_edit.custom_fields.reorder_button": "Упорядочить",
  "account_edit.custom_fields.tip_content": "Вы без особого труда сможете повысить доверие к своему профилю в Mastodon, если верифицируете ссылки на принадлежащие вам сайты.",
  "account_edit.custom_fields.tip_title": "Подсказка: Добавьте верифицированные ссылки",
  "account_edit.custom_fields.title": "Дополнительные поля",
  "account_edit.custom_fields.verified_hint": "Как мне добавить верифицированную ссылку?",
  "account_edit.display_name.add_label": "Добавить отображаемое имя",
  "account_edit.display_name.edit_label": "Редактировать отображаемое имя",
  "account_edit.display_name.placeholder": "Отображаемое имя — это то, как вы будете подписаны в профиле и лентах.",
  "account_edit.display_name.title": "Отображаемое имя",
  "account_edit.featured_hashtags.edit_label": "Добавить хештеги",
  "account_edit.featured_hashtags.placeholder": "Укажите наиболее интересные для вас темы и предоставьте быстрый доступ к ним.",
  "account_edit.featured_hashtags.title": "Рекомендации хештегов",
  "account_edit.field_actions.delete": "Удалить поле профиля",
  "account_edit.field_actions.edit": "Редактировать поле профиля",
  "account_edit.field_delete_modal.confirm": "Вы уверены, что хотите удалить поле профиля? Это действие невозможно отменить.",
  "account_edit.field_delete_modal.delete_button": "Удалить",
  "account_edit.field_delete_modal.title": "Удалить поле профиля?",
  "account_edit.field_edit_modal.add_title": "Создать поле профиля",
  "account_edit.field_edit_modal.discard_confirm": "Сбросить",
  "account_edit.field_edit_modal.discard_message": "У вас есть несохраненные изменения. Вы уверены, хотите сбросить их?",
  "account_edit.field_edit_modal.edit_title": "Редактировать поле профиля",
  "account_edit.field_edit_modal.length_warning": "Превышено рекомендуемое количество символов. Пользователи, просматривающие ваш профиль с мобильных устройств, могут не увидеть всю строку целиком.",
  "account_edit.field_edit_modal.link_emoji_warning": "Мы не рекомендуем использовать нестандартные эмодзи вместе со ссылками. Если поле профиля содержит и URL-адрес, и эмодзи, оно будет отображено без форматирования, чтобы не сбивать с толку пользователей.",
  "account_edit.field_edit_modal.name_hint": "Например: «Сайт»",
  "account_edit.field_edit_modal.name_label": "Свойство",
  "account_edit.field_edit_modal.url_warning": "Ссылка не будет создана, если вы не укажете {protocol} в начале.",
  "account_edit.field_edit_modal.value_hint": "Например: «https://example.me»",
  "account_edit.field_edit_modal.value_label": "Значение",
  "account_edit.field_reorder_modal.drag_cancel": "Перемещение отменено. Поле \"{item}\" было оставлено на прежнем месте.",
  "account_edit.field_reorder_modal.drag_end": "Поле \"{item}\" было перемещено.",
  "account_edit.field_reorder_modal.drag_instructions": "Чтобы упорядочить дополнительные поля, нажмите \"Пробел\" (Space) или \"Ввод\" (Enter). Используйте клавиши со стрелками, чтобы передвинуть поле вверх или вниз. Нажмите \"Пробел\" (Space) или \"Ввод\" (Enter) ещё раз, чтобы переместить поле на новое место, либо нажмите кнопку \"Выйти\" (Escape) для отмены перемещения.",
  "account_edit.field_reorder_modal.drag_move": "Поле \"{item}\" было передвинуто.",
  "account_edit.field_reorder_modal.drag_over": "Поле \"{item}\" было передвинуто на поле \"{over}\".",
  "account_edit.field_reorder_modal.drag_start": "Выбрано поле \"{item}\".",
  "account_edit.field_reorder_modal.handle_label": "Переместить поле \"{item}\"",
  "account_edit.field_reorder_modal.title": "Упорядочить поля профиля",
  "account_edit.image_alt_modal.add_title": "Добавить альтернативный текст",
  "account_edit.image_alt_modal.details_content": "НУЖНО: <ul> <li>Описывать себя по изображению</li> <li>Говорить о себе в третьем лице, то есть, например, писать «Саша» вместо «я»</li> <li>Придерживаться краткости и лаконичности — нескольких слов вполне достаточно</li> </ul> НЕ НУЖНО: <ul> <li>Начинать со слова «Фото» — это избыточная информация для программ чтения с экрана</li> </ul> ПРИМЕР: <ul> <li>«Саша в зелёной рубашке и очках»</li> </ul>",
  "account_edit.image_alt_modal.details_title": "Советы по описанию фото профиля",
  "account_edit.image_alt_modal.edit_title": "Редактировать альтернативный текст",
  "account_edit.image_alt_modal.text_hint": "Альтернативный текст помогает пользователям программ для чтения с экрана понимать визуальное содержимое.",
  "account_edit.image_alt_modal.text_label": "Альтернативный текст",
  "account_edit.image_delete_modal.confirm": "Вы уверены, что хотите удалить изображение? Это действие невозможно отменить.",
  "account_edit.image_delete_modal.delete_button": "Удалить",
  "account_edit.image_delete_modal.title": "Удалить изображение?",
  "account_edit.image_edit.add_button": "Загрузить изображение",
  "account_edit.image_edit.alt_add_button": "Добавить описание",
  "account_edit.image_edit.alt_edit_button": "Редактировать описание",
  "account_edit.image_edit.remove_button": "Удалить изображение",
  "account_edit.image_edit.replace_button": "Заменить изображение",
  "account_edit.item_list.delete": "Удалить {name}",
  "account_edit.item_list.edit": "Редактировать {name}",
  "account_edit.name_modal.add_title": "Добавить отображаемое имя",
  "account_edit.name_modal.edit_title": "Редактировать отображаемое имя",
  "account_edit.profile_tab.button_label": "Настроить",
  "account_edit.profile_tab.hint.description": "Эти настройки определяют, что будет видно пользователям сервера {server} в официальных приложениях, в то время как пользователи других серверов и сторонних приложений могут не учитывать эти настройки.",
  "account_edit.profile_tab.hint.title": "Внешний вид может отличаться",
  "account_edit.profile_tab.show_featured.description": "«Рекомендации» — это дополнительная вкладка, на которой вы можете показать другие профили.",
  "account_edit.profile_tab.show_featured.title": "Показывать вкладку «Рекомендации»",
  "account_edit.profile_tab.show_media.description": "«Медиа» — это дополнительная вкладка, на которой будут показаны ваши посты, содержащие изображения и видео.",
  "account_edit.profile_tab.show_media.title": "Показывать вкладку «Медиа»",
  "account_edit.profile_tab.show_media_replies.description": "Когда эта опция включена, на вкладке «Медиа» будут показаны в том числе ваши ответы на посты других людей.",
  "account_edit.profile_tab.show_media_replies.title": "Показывать ответы на вкладке «Медиа»",
  "account_edit.profile_tab.show_relations.description": "Показывать списки ваших подписок и подписчиков в профиле. Люди, на которых вы подписаны, будут знать о том, что вы на них подписаны, вне зависимости от этой настройки.",
  "account_edit.profile_tab.show_relations.title": "Показывать мои подписки и моих подписчиков",
  "account_edit.profile_tab.subtitle": "Укажите, что будет отображаться в вашем профиле.",
  "account_edit.profile_tab.title": "Настройки отображения профиля",
  "account_edit.save": "Сохранить",
  "account_edit.upload_modal.back": "Назад",
  "account_edit.upload_modal.done": "Готово",
  "account_edit.upload_modal.next": "Далее",
  "account_edit.upload_modal.step_crop.zoom": "Масштаб",
  "account_edit.upload_modal.step_upload.button": "Обзор файлов",
  "account_edit.upload_modal.step_upload.dragging": "Перетащите сюда, чтобы загрузить",
  "account_edit.upload_modal.step_upload.header": "Выберите изображение",
  "account_edit.upload_modal.step_upload.hint": "Поддерживаются файлы WEBP, PNG, GIF и JPG размером не более {limit} МБ.{br}Изображение будет уменьшено до {width}x{height} пикселей.",
  "account_edit.upload_modal.title_add.avatar": "Добавить фото профиля",
  "account_edit.upload_modal.title_add.header": "Добавить обложку профиля",
  "account_edit.upload_modal.title_replace.avatar": "Заменить фото профиля",
  "account_edit.upload_modal.title_replace.header": "Заменить обложку профиля",
  "account_edit.verified_modal.details": "Чтобы развеять сомнения в подлинности профиля, вы можете верифицировать ссылки на ваш сайт. Делается это так:",
  "account_edit.verified_modal.invisible_link.details": "Разместите на своём сайте ссылку на ваш профиль. Ключевое значение имеет атрибут rel=\"me\", который не даёт выдать себя за другое лицо на сайтах, где контент создают сами пользователи. Вместо тега {tag} можно использовать тег <link> в <head>-секции страницы, но необходимо, чтобы HTML-код был доступен без выполнения JavaScript.",
  "account_edit.verified_modal.invisible_link.summary": "Как сделать ссылку невидимой?",
  "account_edit.verified_modal.step1.header": "Скопируйте и вставьте следующий код в HTML-разметку вашего сайта:",
  "account_edit.verified_modal.step2.details": "Если в вашем профиле уже есть дополнительное поле со ссылкой на ваш сайт, вам нужно будет удалить его и добавить заново, чтобы запустить верификацию.",
  "account_edit.verified_modal.step2.header": "Создайте новое поле профиля со ссылкой на ваш сайт",
  "account_edit.verified_modal.title": "Добавление верифицированных ссылок",
  "account_edit_tags.add_tag": "Добавить #{tagName}",
  "account_edit_tags.column_title": "Редактировать теги",
  "account_edit_tags.help_text": "Рекомендации хештегов помогают другим пользователям изучить ваш профиль и взаимодействовать с вами. Они будут показаны в виде фильтров над постами на странице вашего профиля.",
  "account_edit_tags.max_tags_reached": "Вы достигли максимального количества рекомендаций хештегов.",
  "account_edit_tags.search_placeholder": "Введите хештег…",
  "account_edit_tags.suggestions": "Подсказки:",
  "account_edit_tags.tag_status_count": "{count, plural, one {# пост} few {# поста} other {# постов}}",
  "account_list.hidden_notice": "Этот список виден только вам. Чтобы другие люди тоже могли его видеть, включите соответствующую опцию: <link>Редактировать профиль → {modal} → {field}</link>.",
  "account_list.total": "{total, plural, one {# пользователь} few {# пользователя} other {# пользователей}}",
  "admin.dashboard.daily_retention": "Уровень удержания пользователей после регистрации, в днях",
  "admin.dashboard.monthly_retention": "Уровень удержания пользователей после регистрации, в месяцах",
  "admin.dashboard.retention.average": "В среднем",
  "admin.dashboard.retention.cohort": "Месяц регистрации",
  "admin.dashboard.retention.cohort_size": "Новые пользователи",
  "admin.impact_report.instance_accounts": "Число профилей, которые будут удалены",
  "admin.impact_report.instance_followers": "Число подписчиков, которых лишатся наши пользователи",
  "admin.impact_report.instance_follows": "Число подписчиков, которых лишатся их пользователи",
  "admin.impact_report.title": "Сводка последствий",
  "alert.rate_limited.message": "Подождите до {retry_time, time, medium}, прежде чем делать что-либо ещё.",
  "alert.rate_limited.title": "Слишком много запросов",
  "alert.unexpected.message": "Произошла непредвиденная ошибка.",
  "alert.unexpected.title": "Ой!",
  "alt_text_badge.title": "Альтернативный текст",
  "alt_text_modal.add_alt_text": "Альтернативный текст",
  "alt_text_modal.add_text_from_image": "Добавить текст из изображения",
  "alt_text_modal.cancel": "Отмена",
  "alt_text_modal.change_thumbnail": "Изменить обложку",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Добавьте описание для людей с нарушениями слуха…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Добавьте описание для людей с нарушениями зрения…",
  "alt_text_modal.done": "Готово",
  "announcement.announcement": "Объявление",
  "annual_report.announcement.action_build": "Сгенерировать свой Wrapstodon",
  "annual_report.announcement.action_dismiss": "Нет, спасибо",
  "annual_report.announcement.action_view": "Перейти к своему Wrapstodon",
  "annual_report.announcement.description": "Узнайте больше о своей активности в Mastodon за прошедший год.",
  "annual_report.announcement.title": "Пришло время Wrapstodon {year}!",
  "annual_report.nav_item.badge": "New",
  "annual_report.shared_page.donate": "Пожертвовать",
  "annual_report.shared_page.footer": "Сгенерировано с {heart} командой Mastodon",
  "annual_report.shared_page.footer_server_info": "{username} использует сервер {domain} — одно из множества сообществ на базе Mastodon.",
  "annual_report.summary.archetype.booster.desc_public": "{name} весь год выслеживал(а) стоящие посты, продвигая их авторов метким нажатием кнопки.",
  "annual_report.summary.archetype.booster.desc_self": "Вы весь год выслеживали стоящие посты, продвигая их авторов метким нажатием кнопки.",
  "annual_report.summary.archetype.booster.name": "Репостер",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "Мы знаем, что {name} был(а) где-то здесь, по-своему получая удовольствие от использования Mastodon.",
  "annual_report.summary.archetype.lurker.desc_self": "Мы знаем, что вы были где-то здесь, по-своему получая удовольствие от использования Mastodon.",
  "annual_report.summary.archetype.lurker.name": "Молчун",
  "annual_report.summary.archetype.oracle.desc_public": "{name} чаще писал(а) новые посты, чем ответы, поддерживая Mastodon актуальным и обращённым в будущее.",
  "annual_report.summary.archetype.oracle.desc_self": "Вы чаще писали новые посты, чем ответы, поддерживая Mastodon актуальным и обращённым в будущее.",
  "annual_report.summary.archetype.oracle.name": "Гуру",
  "annual_report.summary.archetype.pollster.desc_public": "{name} создал(а) много опросов по сравнению с другими видами постов, взращивая любопытство в Mastodon.",
  "annual_report.summary.archetype.pollster.desc_self": "Вы создали много опросов по сравнению с другими видами постов, взращивая любопытство в Mastodon.",
  "annual_report.summary.archetype.pollster.name": "Опросчик",
  "annual_report.summary.archetype.replier.desc_public": "{name} часто писал(а) ответы на посты других людей, обогащая Mastodon новыми обсуждениями.",
  "annual_report.summary.archetype.replier.desc_self": "Вы часто писали ответы на посты других людей, обогащая Mastodon новыми обсуждениями.",
  "annual_report.summary.archetype.replier.name": "Душа компании",
  "annual_report.summary.archetype.reveal": "Раскрыть мой архетип",
  "annual_report.summary.archetype.reveal_description": "Спасибо за то, что были вместе с Mastodon! Пора узнать, какой архетип вы олицетворяли собой в {year} году.",
  "annual_report.summary.archetype.title_public": "Архетип пользователя {name}",
  "annual_report.summary.archetype.title_self": "Мой архетип",
  "annual_report.summary.close": "Закрыть",
  "annual_report.summary.copy_link": "Копировать ссылку",
  "annual_report.summary.followers.new_followers": "{count, plural, one {новый подписчик} many {новых подписчиков} other {новых подписчика}}",
  "annual_report.summary.highlighted_post.boost_count": "Этот пост был продвинут {count, plural, one {# раз} many {# раз} other {# раза}}.",
  "annual_report.summary.highlighted_post.favourite_count": "Этот пост добавили в избранное {count, plural, one {# раз} many {# раз} other {# раза}}.",
  "annual_report.summary.highlighted_post.reply_count": "Этот пост получил {count, plural, one {# ответ} many {# ответов} other {# ответа}}.",
  "annual_report.summary.highlighted_post.title": "Самый популярный пост",
  "annual_report.summary.most_used_app.most_used_app": "наиболее часто используемое приложение",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "наиболее часто используемый хештег",
  "annual_report.summary.most_used_hashtag.used_count": "Вы использовали этот хештег в {count, plural, one {# посте} other {# постах}}.",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} использовал(а) этот хештег в {count, plural, one {# посте} other {# постах}}.",
  "annual_report.summary.new_posts.new_posts": "новых постов",
  "annual_report.summary.percentile.text": "<topLabel>Всё это помещает вас в топ</topLabel><percentage></percentage><bottomLabel>пользователей {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Роскомнадзор об этом не узнает.",
  "annual_report.summary.share_elsewhere": "Поделиться в…",
  "annual_report.summary.share_message": "Мой архетип — {archetype}!",
  "annual_report.summary.share_on_mastodon": "Поделиться в Mastodon",
  "attachments_list.unprocessed": "(не обработан)",
  "audio.hide": "Скрыть аудио",
  "block_modal.no_collections": "Никто из вас не сможет добавлять друг друга в подборки. Вы и этот пользователь будете взаимно удалены из существующих подборок друг друга.",
  "block_modal.remote_users_caveat": "Мы попросим сервер {domain} уважать ваше решение, однако нельзя гарантировать, что он будет соблюдать блокировку, поскольку некоторые серверы могут по-разному обрабатывать запросы. Публичные посты по-прежнему могут быть видны неавторизованным пользователям.",
  "block_modal.show_less": "Показать меньше",
  "block_modal.show_more": "Показать больше",
  "block_modal.they_cant_mention": "Вы не сможете упоминать или цитировать друг друга. Вы не сможете подписаться на этого пользователя, а он не сможет подписаться на вас.",
  "block_modal.they_cant_see_posts": "Он не сможет видеть ваши посты, а вы не будете видеть его посты.",
  "block_modal.they_will_know": "Он будет знать, что вы его блокируете.",
  "block_modal.title": "Заблокировать пользователя?",
  "block_modal.you_wont_see_mentions": "Вы не увидите посты, которые его упоминают.",
  "boost_modal.combo": "{combo}, чтобы пропустить это в следующий раз",
  "boost_modal.reblog": "Продвинуть пост?",
  "boost_modal.undo_reblog": "Отменить продвижение?",
  "bundle_column_error.copy_stacktrace": "Копировать отчёт об ошибке",
  "bundle_column_error.error.body": "Запрошенная страница не может быть отображена. Это могло произойти из-за ошибки в нашем коде или из-за проблемы совместимости браузера.",
  "bundle_column_error.error.title": "О нет!",
  "bundle_column_error.network.body": "При загрузке этой страницы произошла ошибка. Она могла быть вызвана временными проблемами либо с вашим подключением к интернету, либо с этим сервером.",
  "bundle_column_error.network.title": "Ошибка сети",
  "bundle_column_error.retry": "Попробовать снова",
  "bundle_column_error.return": "Вернуться на главную",
  "bundle_column_error.routing.body": "Запрошенная страница не найдена. Вы уверены, что в адресной строке указан правильный URL?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Закрыть",
  "bundle_modal_error.message": "Кое-что пошло не так при загрузке этой страницы.",
  "bundle_modal_error.retry": "Попробовать снова",
  "callout.dismiss": "Закрыть",
  "carousel.current": "<sr>Слайд</sr> {current, number} / {max, number}",
  "carousel.slide": "Слайд {current, number} из {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} символов",
  "character_counter.required": "{currentLength}/{maxLength} символов",
  "closed_registrations.other_server_instructions": "Благодаря тому что Mastodon децентрализован, вы можете взаимодействовать с этим сервером, даже если зарегистрируетесь на другом сервере.",
  "closed_registrations_modal.description": "Зарегистрироваться на {domain} сейчас не выйдет, но имейте в виду, что вам не нужна учётная запись именно на {domain}, чтобы использовать Mastodon.",
  "closed_registrations_modal.find_another_server": "Найти другой сервер",
  "closed_registrations_modal.preamble": "Mastodon децентрализован, поэтому независимо от того, где именно вы зарегистрируетесь, вы сможете подписываться на кого угодно и взаимодействовать с кем угодно на этом сервере. Вы даже можете создать свой собственный сервер!",
  "closed_registrations_modal.title": "Регистрация в Mastodon",
  "collection.share_modal.share_link_label": "Поделиться ссылкой",
  "collection.share_modal.share_via_post": "Опубликовать в Mastodon",
  "collection.share_modal.share_via_system": "Поделиться…",
  "collection.share_modal.title": "Поделиться подборкой",
  "collection.share_modal.title_new": "Поделитесь вашей новой подборкой!",
  "collection.share_template_other": "Зацените эту замечательную подборку:",
  "collection.share_template_own": "Зацените мою новую подборку:",
  "collections.account_count": "{count, plural, one {# пользователь} few {# пользователя} other {# пользователей}}",
  "collections.accounts.empty_description": "Вы можете добавить максимум {count} пользователей",
  "collections.accounts.empty_editor_title": "В этой подборке пока никого нет",
  "collections.accounts.empty_title": "В этой подборке пока никого нет",
  "collections.add_to_collection": "Добавить {name} в подборки",
  "collections.block_collection_owner": "Заблокировать пользователя",
  "collections.by_account": "составил(а) {account_handle}",
  "collections.collection_description": "Описание",
  "collections.collection_language": "Язык",
  "collections.collection_language_none": "Не выбран",
  "collections.collection_name": "Название",
  "collections.collection_topic": "Тематика",
  "collections.confirm_account_removal": "Вы уверены, что хотите исключить этого пользователя из подборки?",
  "collections.content_warning": "Предупреждение о содержании",
  "collections.continue": "Продолжить",
  "collections.copy_link": "Копировать ссылку",
  "collections.copy_link_confirmation": "Ссылка на подборку скопирована в буфер обмена",
  "collections.create.accounts_title": "Кого вы выберете для этой подборки?",
  "collections.create.basic_details_title": "Основная информация",
  "collections.create.steps": "Шаг {step}/{total}",
  "collections.create_collection": "Создать подборку",
  "collections.delete_collection": "Удалить подборку",
  "collections.description_length_hint": "Не более 100 символов",
  "collections.detail.author_added_you_on_date": "{author} добавил(а) вас {date}",
  "collections.detail.loading": "Подборка загружается…",
  "collections.detail.revoke_inclusion": "Выйти из подборки",
  "collections.detail.sensitive_content": "Содержимое деликатного характера",
  "collections.detail.sensitive_note": "Описание подборки и пользователи в ней могут подходить не для всех.",
  "collections.detail.share": "Поделиться подборкой",
  "collections.detail.you_are_in_this_collection": "Вас выбрали для этой подборки",
  "collections.edit_details": "Редактировать",
  "collections.error_loading_collections": "При загрузке подборок произошла ошибка.",
  "collections.hidden_accounts_description": "Вы заблокировали либо игнорируете {count, plural, other {этих пользователей}}",
  "collections.hidden_accounts_link": "{count, plural, one {# пользователь скрыт} few {# пользователя скрыто} many {# пользователей скрыто} other {# пользователя скрыто}}",
  "collections.hints.accounts_counter": "{count}/{max} пользователей",
  "collections.last_updated_at": "Последнее обновление: {date}",
  "collections.list.collections_with_count": "{count, plural, one {# подборка} few {# подборки} other {# подборок}}",
  "collections.list.created_by_author": "Созданные пользователем",
  "collections.list.created_by_you": "Созданные мной",
  "collections.list.featuring_you": "С моим участием",
  "collections.manage_accounts": "Добавить или исключить пользователей",
  "collections.mark_as_sensitive": "Отметить как содержимое деликатного характера",
  "collections.mark_as_sensitive_hint": "Описание этой подборки и пользователи в ней будут скрыты за предупреждением о содержании. Название подборки будет видно всем.",
  "collections.maximum_collection_count_description": "Настройки вашего сервера позволяют создать максимум {count} подборок.",
  "collections.maximum_collection_count_reached": "Вы достигли максимального количества подборок",
  "collections.name_length_hint": "Не более 40 символов",
  "collections.new_collection": "Создать подборку",
  "collections.pending_accounts.message": "Пользователи могут отображаться как неподтверждённые, пока мы ожидаем ответа от пользователя или его сервера. Только вы можете видеть неподтверждённых пользователей.",
  "collections.pending_accounts.title": "Почему некоторые пользователи отмечены как неподтверждённые?",
  "collections.remove_account": "Исключить",
  "collections.report_collection": "Пожаловаться на подборку",
  "collections.revoke_collection_inclusion": "Исключить себя из этой подборки",
  "collections.revoke_inclusion.confirmation": "Вы были исключены из подборки «{collection}»",
  "collections.revoke_inclusion.error": "Произошла ошибка, повторите попытку позже.",
  "collections.search_accounts_label": "Найти и добавить пользователя",
  "collections.search_accounts_max_reached": "Вы добавили максимальное количество пользователей",
  "collections.sensitive": "Содержимое деликатного характера",
  "collections.share_short": "Поделиться",
  "collections.sort_alphabetical": "По алфавиту",
  "collections.sort_by": "Сортировка:",
  "collections.sort_date_added": "По дате добавления",
  "collections.sort_last_active": "По последней активности",
  "collections.sort_most_followers": "По количеству подписчиков",
  "collections.suggestions.can_not_add": "Пользователи, которые не могут быть добавлены",
  "collections.suggestions.can_not_add_desc": "Эти пользователи могли отказаться от обнаружения через рекомендации, либо их сервер не поддерживает подборки.",
  "collections.suggestions.must_follow": "Необходимо сначала подписаться",
  "collections.suggestions.must_follow_desc": "Эти пользователи вручную рассматривают все запросы на подписку. Подписчики могут добавлять их в подборки.",
  "collections.topic_hint": "Добавьте хештег, чтобы помочь другим пользователям лучше понять главную тему этой подборки.",
  "collections.topic_special_chars_hint": "При сохранении специальные символы будут удалены",
  "collections.unlisted_collections_description": "Эти подборки не будут показаны в вашем профиле другим людям. Просматривать их может любой, у кого есть ссылка.",
  "collections.unlisted_collections_with_count": "Скрытые подборки ({count})",
  "collections.view_collection": "Открыть подборку",
  "collections.visibility_public": "Публичная",
  "collections.visibility_public_hint": "Доступна в результатах поиска и других разделах, в которых появляются рекомендации.",
  "collections.visibility_title": "Видимость",
  "collections.visibility_unlisted": "Скрытая",
  "collections.visibility_unlisted_hint": "Доступна всем, у кого есть ссылка. Скрыта из результатов поиска и рекомендаций.",
  "column.about": "О проекте",
  "column.blocks": "Заблокированные пользователи",
  "column.bookmarks": "Закладки",
  "column.community": "Локальная лента",
  "column.create_list": "Создать список",
  "column.direct": "Личные упоминания",
  "column.directory": "Каталог профилей",
  "column.domain_blocks": "Заблокированные домены",
  "column.edit_list": "Редактировать список",
  "column.favourites": "Избранное",
  "column.firehose": "Живая лента",
  "column.firehose_local": "Локальная лента",
  "column.firehose_singular": "Глобальная лента",
  "column.follow_requests": "Запросы на подписку",
  "column.home": "Главная",
  "column.list_members": "Пользователи в списке",
  "column.lists": "Списки",
  "column.mutes": "Игнорируемые пользователи",
  "column.notifications": "Уведомления",
  "column.other_collections": "Подборки пользователя {name}",
  "column.pins": "Закреплённые посты",
  "column.public": "Глобальная лента",
  "column.your_collections": "Мои подборки",
  "column_back_button.label": "Назад",
  "column_header.hide_settings": "Скрыть настройки",
  "column_header.moveLeft_settings": "Передвинуть колонку влево",
  "column_header.moveRight_settings": "Передвинуть колонку вправо",
  "column_header.pin": "Закрепить",
  "column_header.show_settings": "Показать настройки",
  "column_header.unpin": "Открепить",
  "column_search.cancel": "Отмена",
  "combobox.close_results": "Скрыть результаты",
  "combobox.loading": "Загрузка",
  "combobox.no_results_found": "Поиск не дал результатов",
  "combobox.open_results": "Показать результаты",
  "combobox.results_available": "Поиск дал {count, plural, one {# результат} few {# результата} other {# результатов}}. Используйте клавиши со стрелками для навигации. Чтобы выбрать, нажмите Enter.",
  "community.column_settings.local_only": "Только локальные",
  "community.column_settings.media_only": "Только с медиафайлами",
  "community.column_settings.remote_only": "Только с других серверов",
  "compose.error.blank_post": "Нельзя опубликовать пустой пост.",
  "compose.language.change": "Изменить язык",
  "compose.language.search": "Найти язык...",
  "compose.published.body": "Пост опубликован.",
  "compose.published.open": "Открыть",
  "compose.saved.body": "Пост отредактирован.",
  "compose_form.direct_message_warning_learn_more": "Узнать больше",
  "compose_form.encryption_warning": "Посты в Mastodon не защищены сквозным шифрованием. Не делитесь конфиденциальной информацией через Mastodon.",
  "compose_form.hashtag_warning": "Этот пост не появится в поиске по хештегам, так как он не обозначен как публичный. Только публичные посты можно найти по хештегу.",
  "compose_form.lock_disclaimer": "Ваша учётная запись {locked}. Любой пользователь сможет подписаться на вас и просматривать посты для подписчиков.",
  "compose_form.lock_disclaimer.lock": "не закрыта",
  "compose_form.placeholder": "О чём думаете?",
  "compose_form.poll.duration": "Продолжительность",
  "compose_form.poll.multiple": "Несколько вариантов ответа",
  "compose_form.poll.option_placeholder": "Вариант {number}",
  "compose_form.poll.single": "Один вариант ответа",
  "compose_form.poll.switch_to_multiple": "Переключить в режим выбора нескольких вариантов ответа",
  "compose_form.poll.switch_to_single": "Переключить в режим выбора одного варианта ответа",
  "compose_form.poll.type": "Тип",
  "compose_form.publish": "Опубликовать",
  "compose_form.reply": "Ответить",
  "compose_form.save_changes": "Сохранить",
  "compose_form.spoiler.marked": "Удалить предупреждение о содержании",
  "compose_form.spoiler.unmarked": "Добавить предупреждение о содержании",
  "compose_form.spoiler_placeholder": "Предупреждение о содержании (необязательно)",
  "confirmation_modal.cancel": "Отмена",
  "confirmations.block.confirm": "Заблокировать",
  "confirmations.delete.confirm": "Удалить",
  "confirmations.delete.message": "Вы уверены, что хотите удалить этот пост?",
  "confirmations.delete.title": "Удалить пост?",
  "confirmations.delete_collection.confirm": "Удалить",
  "confirmations.delete_collection.message": "Это действие невозможно отменить.",
  "confirmations.delete_collection.title": "Удалить подборку «{name}»?",
  "confirmations.delete_list.confirm": "Удалить",
  "confirmations.delete_list.message": "Вы уверены, что хотите навсегда удалить этот список?",
  "confirmations.delete_list.title": "Удалить список?",
  "confirmations.discard_draft.confirm": "Сбросить и продолжить",
  "confirmations.discard_draft.edit.cancel": "Вернуться к редактированию",
  "confirmations.discard_draft.edit.message": "Если вы продолжите, то все изменения в редактируемом в данный момент посте будут отброшены.",
  "confirmations.discard_draft.edit.title": "Сбросить несохранённые изменения?",
  "confirmations.discard_draft.post.cancel": "Вернуться к черновику",
  "confirmations.discard_draft.post.message": "Если вы продолжите, то набираемый в данный момент пост будет стёрт.",
  "confirmations.discard_draft.post.title": "Стереть несохранённый черновик поста?",
  "confirmations.discard_edit_media.confirm": "Сбросить",
  "confirmations.discard_edit_media.message": "У вас есть несохранённые изменения, касающиеся описания медиа или области предпросмотра. Сбросить их?",
  "confirmations.follow_to_list.confirm": "Подписаться и добавить",
  "confirmations.follow_to_list.message": "Чтобы добавить пользователя {name} в список, вы должны быть на него подписаны.",
  "confirmations.follow_to_list.title": "Подписаться на пользователя?",
  "confirmations.hide_featured_tab.confirm": "Скрыть вкладку",
  "confirmations.logout.confirm": "Выйти",
  "confirmations.logout.message": "Вы уверены, что хотите выйти?",
  "confirmations.logout.title": "Выйти?",
  "confirmations.missing_alt_text.confirm": "Добавить",
  "confirmations.missing_alt_text.message": "Ваш пост содержит медиа без альтернативного текста. Добавляя описания, вы делаете ваш контент доступным для более широкого круга людей.",
  "confirmations.missing_alt_text.secondary": "Опубликовать",
  "confirmations.missing_alt_text.title": "Добавить альтернативный текст?",
  "confirmations.mute.confirm": "Игнорировать",
  "confirmations.private_quote_notify.cancel": "Вернуться к редактированию",
  "confirmations.private_quote_notify.confirm": "Опубликовать",
  "confirmations.private_quote_notify.do_not_show_again": "Не показывать это сообщение снова",
  "confirmations.private_quote_notify.message": "Пользователь, которого вы процитировали, а также другие упомянутые пользователи будут уведомлены и смогут просмотреть ваш пост, даже если они не подписаны на вас.",
  "confirmations.private_quote_notify.title": "Поделиться с подписчиками и упомянутыми пользователями?",
  "confirmations.quiet_post_quote_info.dismiss": "Больше не напоминать",
  "confirmations.quiet_post_quote_info.got_it": "Понятно",
  "confirmations.quiet_post_quote_info.message": "Если ваш пост содержит цитирование «тихого публичного» поста, он будет скрыт из алгоритмических лент.",
  "confirmations.quiet_post_quote_info.title": "Цитирование «тихих публичных» постов",
  "confirmations.redraft.confirm": "Удалить и исправить",
  "confirmations.redraft.message": "Вы уверены, что хотите удалить этот пост и создать его заново? Взаимодействия, такие как добавление в избранное и продвижение, будут потеряны, а ответы к оригинальному посту перестанут на него ссылаться.",
  "confirmations.redraft.title": "Удалить и создать пост заново?",
  "confirmations.remove_from_followers.confirm": "Убрать подписчика",
  "confirmations.remove_from_followers.message": "Пользователь {name} перестанет быть подписан на вас. Продолжить?",
  "confirmations.remove_from_followers.title": "Убрать подписчика?",
  "confirmations.revoke_collection_inclusion.confirm": "Исключить меня",
  "confirmations.revoke_collection_inclusion.title": "Исключить вас из подборки?",
  "confirmations.revoke_quote.confirm": "Убрать пост",
  "confirmations.revoke_quote.message": "Это действие невозможно отменить.",
  "confirmations.revoke_quote.title": "Убрать пост?",
  "confirmations.unblock.confirm": "Разблокировать",
  "confirmations.unblock.title": "Разблокировать {name}?",
  "confirmations.unfollow.confirm": "Отписаться",
  "confirmations.unfollow.title": "Отписаться от {name}?",
  "confirmations.withdraw_request.confirm": "Отозвать запрос",
  "confirmations.withdraw_request.title": "Отозвать запрос на подписку на {name}?",
  "content_warning.hide": "Скрыть пост",
  "content_warning.show": "Всё равно показать",
  "content_warning.show_more": "Развернуть",
  "content_warning.show_short": "Показать",
  "conversation.delete": "Удалить беседу",
  "conversation.mark_as_read": "Отметить как прочитанное",
  "conversation.open": "Просмотр беседы",
  "conversation.with": "С {names}",
  "copy_icon_button.copied": "Скопировано в буфер обмена",
  "copy_icon_button.copy_this_text": "Копировать ссылку в буфер обмена",
  "copypaste.copied": "Скопировано",
  "copypaste.copy_to_clipboard": "Копировать в буфер обмена",
  "custom_homepage.about": "Подробности",
  "custom_homepage.about_this_server": "Об этом сервере",
  "custom_homepage.administered_by": "Управляется",
  "custom_homepage.contact": "Связаться:",
  "custom_homepage.latest_activity": "Последняя активность",
  "custom_homepage.these_are_the_latest_posts": "Здесь показаны 40 постов, недавно опубликованных пользователями на этом сервере.",
  "directory.federated": "Со всего федивёрса",
  "directory.local": "Только с {domain}",
  "directory.new_arrivals": "Новички",
  "directory.recently_active": "Недавно активные",
  "disabled_account_banner.account_settings": "Настройки учётной записи",
  "disabled_account_banner.text": "Ваша учётная запись {disabledAccount} в настоящее время отключена.",
  "dismissable_banner.community_timeline": "Это самые новые публичные посты от тех пользователей, чьи учётные записи размещены на сервере {domain}.",
  "dismissable_banner.dismiss": "Закрыть",
  "dismissable_banner.public_timeline": "Это самые новые публичные посты от всех тех людей в федивёрсе, на которых подписаны пользователи {domain}.",
  "domain_block_modal.block": "Заблокировать сервер",
  "domain_block_modal.block_account_instead": "Заблокировать @{name}",
  "domain_block_modal.they_can_interact_with_old_posts": "Пользователи с этого сервера смогут взаимодействовать с вашими старыми постами.",
  "domain_block_modal.they_cant_follow": "Пользователи с этого сервера не смогут подписаться на вас.",
  "domain_block_modal.they_wont_know": "Пользователи с этого сервера не будут знать, что вы их блокируете.",
  "domain_block_modal.title": "Заблокировать домен?",
  "domain_block_modal.you_will_lose_num_followers": "Вы потеряете {followersCount, plural, one {{followersCountDisplay} подписчика} few {{followersCountDisplay} подписчиков} other {{followersCountDisplay} подписчиков}} и {followingCount, plural, one {{followingCountDisplay} подписку} few {{followingCountDisplay} подписки} other {{followingCountDisplay} подписок}}.",
  "domain_block_modal.you_will_lose_relationships": "Вы потеряете все подписки и всех подписчиков с этого сервера.",
  "domain_block_modal.you_wont_see_posts": "Вы не будете видеть посты и уведомления от пользователей с этого сервера.",
  "dropdown.empty": "Выберите вариант",
  "email_subscriptions.email": "Адрес электронной почты",
  "email_subscriptions.form.action": "Подписаться",
  "email_subscriptions.form.title": "Оформите email-подписку на этого пользователя",
  "email_subscriptions.submitted.title": "Ещё один шаг",
  "email_subscriptions.validation.email.blocked": "Почтовый сервис заблокирован",
  "email_subscriptions.validation.email.invalid": "Некорректный адрес электронной почты",
  "embed.instructions": "Встройте этот пост на свой сайт, скопировав следующий код:",
  "embed.preview": "Так это будет выглядеть:",
  "emoji_button.activity": "Занятия",
  "emoji_button.clear": "Очистить",
  "emoji_button.custom": "С этого сервера",
  "emoji_button.flags": "Флаги",
  "emoji_button.food": "Еда и напитки",
  "emoji_button.label": "Вставить эмодзи",
  "emoji_button.nature": "Природа",
  "emoji_button.not_found": "Подходящие эмодзи не найдены",
  "emoji_button.objects": "Предметы",
  "emoji_button.people": "Люди",
  "emoji_button.recent": "Часто используемые",
  "emoji_button.search": "Найти...",
  "emoji_button.search_results": "Результаты поиска",
  "emoji_button.symbols": "Символы",
  "emoji_button.travel": "Путешествия и места",
  "empty_column.account_featured.other": "{acct} ещё ничего не рекомендовал(а) в своём профиле.",
  "empty_column.account_featured_self.no_collections_button": "Создать подборку",
  "empty_column.account_featured_unknown.other": "Этот пользователь ещё ничего не рекомендовал в своём профиле.",
  "empty_column.account_hides_collections": "Пользователь предпочёл не раскрывать эту информацию",
  "empty_column.account_suspended": "Учётная запись заблокирована",
  "empty_column.account_timeline": "Здесь нет постов!",
  "empty_column.account_unavailable": "Профиль недоступен",
  "empty_column.blocks": "Вы ещё никого не заблокировали.",
  "empty_column.bookmarked_statuses": "У вас пока нет закладок. Когда вы добавляете пост в закладки, он появляется здесь.",
  "empty_column.community": "Локальная лента пуста. Напишите что-нибудь, чтобы разогреть народ!",
  "empty_column.direct": "Вы ещё не упоминали кого-либо и сами не были ни разу упомянуты лично. Все личные упоминания будут показаны здесь.",
  "empty_column.disabled_feed": "Эта лента была отключена администраторами вашего сервера.",
  "empty_column.domain_blocks": "Заблокированных доменов пока нет.",
  "empty_column.explore_statuses": "Сейчас нет популярных постов. Проверьте позже!",
  "empty_column.favourited_statuses": "Вы ещё не добавили ни одного поста в избранное. Все добавленные вами в избранное посты будут показаны здесь.",
  "empty_column.favourites": "Никто ещё не добавил этот пост в избранное. Все пользователи, которые добавят этот пост в избранное, будут показаны здесь.",
  "empty_column.follow_requests": "Вам ещё не приходили запросы на подписку. Все новые запросы будут показаны здесь.",
  "empty_column.followed_tags": "Вы ещё не подписались ни на один хештег. Все хештеги, на которые вы подписаны, будут показаны здесь.",
  "empty_column.hashtag": "С этим хештегом пока ещё никто ничего не опубликовал.",
  "empty_column.home": "Ваша домашняя лента совсем пуста! Подпишитесь на кого-нибудь, чтобы заполнить её.",
  "empty_column.list": "В этом списке пока ничего нет. Все новые посты, опубликованные пользователями в списке, будут появляться здесь.",
  "empty_column.mutes": "Вы пока что никого не игнорируете.",
  "empty_column.notification_requests": "Здесь ничего нет! Когда вы получите новые уведомления, они здесь появятся согласно вашим настройкам.",
  "empty_column.notifications": "У вас пока нет уведомлений. Взаимодействуйте с другими, чтобы завести разговор.",
  "empty_column.public": "Здесь ничего нет! Опубликуйте что-нибудь или подпишитесь на пользователей с других серверов, чтобы заполнить ленту",
  "empty_state.no_results": "Ничего не найдено",
  "error.no_hashtag_feed_access": "Чтобы просматривать этот хештег или подписаться на него, необходимо зарегистрироваться или войти.",
  "error.unexpected_crash.explanation": "Из-за несовместимого браузера или ошибки в нашем коде эта страница не может быть корректно отображена.",
  "error.unexpected_crash.explanation_addons": "Эта страница не может быть корректно отображена. Скорее всего, ошибка вызвана расширением браузера или инструментом автоматического перевода.",
  "error.unexpected_crash.next_steps": "Попробуйте обновить страницу. Если это не поможет, вы, возможно, всё ещё сможете использовать Mastodon в другом браузере или приложении.",
  "error.unexpected_crash.next_steps_addons": "Попробуйте их отключить и обновить страницу. Если это не поможет, вы, возможно, всё ещё сможете использовать Mastodon в другом браузере или приложении.",
  "errors.unexpected_crash.copy_stacktrace": "Скопировать диагностическую информацию",
  "errors.unexpected_crash.report_issue": "Сообщить о проблеме",
  "explore.suggested_follows": "Люди",
  "explore.title": "Актуальное",
  "explore.trending_links": "Новости",
  "explore.trending_statuses": "Посты",
  "explore.trending_tags": "Хештеги",
  "featured_carousel.current": "<sr>Пост</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, other {Закреплённые посты}}",
  "featured_carousel.slide": "Пост {current, number} из {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions.add": "Добавить",
  "featured_tags.suggestions.dismiss": "Нет, спасибо",
  "filter_modal.added.context_mismatch_explanation": "Этот фильтр не применяется в том контексте, в котором вы видели этот пост. Если вы хотите, чтобы пост был отфильтрован в текущем контексте, необходимо редактировать фильтр.",
  "filter_modal.added.context_mismatch_title": "Несоответствие контекста",
  "filter_modal.added.expired_explanation": "Этот фильтр истёк. Чтобы он был применён, вам нужно изменить срок действия фильтра.",
  "filter_modal.added.expired_title": "Истёкший фильтр",
  "filter_modal.added.review_and_configure": "Для просмотра или редактирования этого фильтра перейдите в {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Настройки фильтра",
  "filter_modal.added.settings_link": "настройки",
  "filter_modal.added.short_explanation": "Этот пост был добавлен к фильтру «{title}».",
  "filter_modal.added.title": "Фильтр добавлен",
  "filter_modal.select_filter.context_mismatch": "не применяется в этом контексте",
  "filter_modal.select_filter.expired": "истёкший",
  "filter_modal.select_filter.prompt_new": "Новый фильтр: {name}",
  "filter_modal.select_filter.search": "Поиск (или введите название нового фильтра)",
  "filter_modal.select_filter.subtitle": "Используйте существующий фильтр или создайте новый",
  "filter_modal.select_filter.title": "Фильтровать этот пост",
  "filter_modal.title.status": "Фильтровать пост",
  "filter_warning.matches_filter": "Соответствует фильтру «<span>{title}</span>»",
  "filtered_notifications_banner.pending_requests": "От {count, plural, =0 {незнакомых вам людей} one {# человека, которого вы можете знать} other {# человек, которых вы можете знать}}",
  "filtered_notifications_banner.title": "Отфильтрованные уведомления",
  "firehose.all": "Всё вместе",
  "firehose.local": "Этот сервер",
  "firehose.remote": "Другие серверы",
  "follow_request.authorize": "Разрешить",
  "follow_request.reject": "Отказать",
  "follow_requests.unlocked_explanation": "Хотя ваша учётная запись не закрыта, команда сервера {domain} подумала, что вы захотите рассмотреть запросы на подписку от этих учётных записей вручную.",
  "follow_suggestions.curated_suggestion": "Выбор команды сервера",
  "follow_suggestions.dismiss": "Не показывать снова",
  "follow_suggestions.featured_longer": "Вручную выбрано командой сервера {domain}",
  "follow_suggestions.friends_of_friends_longer": "Популярно среди людей, на которых вы подписаны",
  "follow_suggestions.hints.featured": "Этот профиль был вручную выбран командой сервера {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Этот профиль популярен среди людей, на которых вы подписаны.",
  "follow_suggestions.hints.most_followed": "Этот профиль лидирует по числу подписчиков с сервера {domain}.",
  "follow_suggestions.hints.most_interactions": "Этот профиль в последнее время привлекает много внимания на сервере {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Этот профиль похож на другие профили, на которые вы подписывались в последнее время.",
  "follow_suggestions.personalized_suggestion": "Персональное предложение",
  "follow_suggestions.popular_suggestion": "Популярное предложение",
  "follow_suggestions.popular_suggestion_longer": "Популярно на сервере {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Похоже на профили, на которые вы подписывались в последнее время",
  "follow_suggestions.view_all": "Посмотреть все",
  "follow_suggestions.who_to_follow": "На кого подписаться",
  "followed_tags": "Подписки на хештеги",
  "followers.title": "Подписчики",
  "following.title": "Подписки",
  "footer.about": "О проекте",
  "footer.about_mastodon": "О проекте",
  "footer.about_server": "О сервере {domain}",
  "footer.about_this_server": "Об этом сервере",
  "footer.directory": "Каталог профилей",
  "footer.get_app": "Скачать приложение",
  "footer.keyboard_shortcuts": "Сочетания клавиш",
  "footer.privacy_policy": "Политика конфиденциальности",
  "footer.source_code": "Исходный код",
  "footer.status": "Состояние сервера",
  "footer.terms_of_service": "Пользовательское соглашение",
  "form_error.blank": "Это поле должно быть заполнено.",
  "form_field.optional": "(необязательно)",
  "getting_started.heading": "Добро пожаловать",
  "hashtag.admin_moderation": "Открыть интерфейс модератора для #{name}",
  "hashtag.browse": "Обзор постов с хештегом #{hashtag}",
  "hashtag.browse_from_account": "Обзор постов от @{name} с хештегом #{hashtag}",
  "hashtag.column_header.tag_mode.all": "и {additional}",
  "hashtag.column_header.tag_mode.any": "или {additional}",
  "hashtag.column_header.tag_mode.none": "без {additional}",
  "hashtag.column_settings.select.no_options_message": "Предложений не найдено",
  "hashtag.column_settings.select.placeholder": "Введите хештеги…",
  "hashtag.column_settings.tag_mode.all": "Все из списка",
  "hashtag.column_settings.tag_mode.any": "Любой из списка",
  "hashtag.column_settings.tag_mode.none": "Ни один из списка",
  "hashtag.column_settings.tag_toggle": "Включить дополнительные теги для этого столбца",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} пользователь} few {{counter} пользователя} other {{counter} пользователей}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} пост} few {{counter} поста} other {{counter} постов}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} пост} few {{counter} поста} other {{counter} постов}} сегодня",
  "hashtag.feature": "Рекомендовать в профиле",
  "hashtag.follow": "Подписаться на хештег",
  "hashtag.mute": "Игнорировать #{hashtag}",
  "hashtag.unfeature": "Не рекомендовать в профиле",
  "hashtag.unfollow": "Отписаться от хештега",
  "hashtags.and_other": "…и {count, plural, other {ещё #}}",
  "hints.profiles.followers_may_be_missing": "Некоторые подписчики этого профиля могут здесь отсутствовать.",
  "hints.profiles.follows_may_be_missing": "Некоторые подписки этого профиля могут здесь отсутствовать.",
  "hints.profiles.posts_may_be_missing": "Некоторые посты в этом профиле могут здесь отсутствовать.",
  "hints.profiles.see_more_followers": "Перейдите на {domain}, чтобы увидеть всех подписчиков",
  "hints.profiles.see_more_follows": "Перейдите на {domain}, чтобы увидеть все подписки",
  "hints.profiles.see_more_posts": "Перейдите на {domain}, чтобы увидеть все посты",
  "home.column_settings.show_quotes": "Показывать цитирования",
  "home.column_settings.show_reblogs": "Показывать продвижения",
  "home.column_settings.show_replies": "Показывать ответы",
  "home.hide_announcements": "Скрыть объявления",
  "home.pending_critical_update.body": "Пожалуйста, обновите свой сервер Mastodon как можно скорее!",
  "home.pending_critical_update.link": "Посмотреть обновления",
  "home.pending_critical_update.title": "Доступно критическое обновление безопасности",
  "home.show_announcements": "Показать объявления",
  "ignore_notifications_modal.bots_title": "Игнорировать уведомления от ботов?",
  "ignore_notifications_modal.disclaimer": "Mastodon не может сообщить пользователям, что вы игнорируете их уведомления. Игнорирование уведомлений не остановит отправку самих сообщений.",
  "ignore_notifications_modal.filter_instead": "Фильтровать",
  "ignore_notifications_modal.filter_to_act_users": "Вы по-прежнему сможете принимать и отклонять запросы, а также отправлять жалобы на пользователей",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Фильтрация поможет избежать возможной путаницы",
  "ignore_notifications_modal.filter_to_review_separately": "Отфильтрованные уведомления можно просматривать отдельно",
  "ignore_notifications_modal.ignore": "Игнорировать уведомления",
  "ignore_notifications_modal.limited_accounts_title": "Игнорировать уведомления от модерируемых учётных записей?",
  "ignore_notifications_modal.new_accounts_title": "Игнорировать уведомления от новых учётных записей?",
  "ignore_notifications_modal.not_followers_title": "Игнорировать уведомления от людей, не подписанных на вас?",
  "ignore_notifications_modal.not_following_title": "Игнорировать уведомления от людей, на которых вы не подписаны?",
  "ignore_notifications_modal.private_mentions_title": "Игнорировать уведомления о нежелательных личных упоминаниях?",
  "info_button.label": "Помощь",
  "info_button.what_is_alt_text": "<h1>Что это такое?</h1> <p>Альтернативный текст содержит описание изображения для людей с ограничениями зрения, медленным интернетом и для тех, кому нужен дополнительный контекст.</p> <p>Вы можете улучшить доступность и понимание для всех, написав чёткий, краткий и объективный альтернативный текст.</p> <ul> <li>Уловите важные элементы</li> <li>Перескажите текстовую информацию на изображении</li> <li>Используйте правильную структуру предложений</li> <li>Избегайте избыточной информации</li> <li>Сосредоточьтесь на тенденциях и ключевых выводах при описании сложных визуализаций, таких как диаграммы или карты</li> </ul>",
  "interaction_modal.action": "Войдите в учётную запись на своём сервере Mastodon, чтобы взаимодействовать с этим постом.",
  "interaction_modal.action_follow": "Войдите в учётную запись на своём сервере Mastodon, чтобы подписаться на этого пользователя.",
  "interaction_modal.go": "Вперёд!",
  "interaction_modal.no_account_yet": "У вас нет никакой учётной записи?",
  "interaction_modal.on_another_server": "На другом сервере",
  "interaction_modal.on_this_server": "На этом сервере",
  "interaction_modal.title": "Войдите, чтобы продолжить",
  "interaction_modal.username_prompt": "Например: {example}",
  "intervals.full.days": "{number, plural, one {# день} few {# дня} other {# дней}}",
  "intervals.full.hours": "{number, plural, one {# час} few {# часа} other {# часов}}",
  "intervals.full.minutes": "{number, plural, one {# минута} few {# минуты} other {# минут}}",
  "keyboard_shortcuts.back": "перейти назад",
  "keyboard_shortcuts.blocked": "открыть список заблокированных пользователей",
  "keyboard_shortcuts.boost": "продвинуть пост",
  "keyboard_shortcuts.column": "фокус на одном из столбцов",
  "keyboard_shortcuts.compose": "фокус на поле ввода",
  "keyboard_shortcuts.description": "Описание",
  "keyboard_shortcuts.direct": "перейти к личным упоминаниям",
  "keyboard_shortcuts.down": "вниз по списку",
  "keyboard_shortcuts.enter": "открыть пост",
  "keyboard_shortcuts.explore": "перейти в раздел «Актуальное»",
  "keyboard_shortcuts.favourite": "добавить пост в избранное",
  "keyboard_shortcuts.favourites": "перейти к избранным постам",
  "keyboard_shortcuts.federated": "перейти к глобальной ленте",
  "keyboard_shortcuts.heading": "Сочетания клавиш",
  "keyboard_shortcuts.home": "перейти к домашней ленте",
  "keyboard_shortcuts.hotkey": "Горячая клавиша",
  "keyboard_shortcuts.keys.alt": "Alt",
  "keyboard_shortcuts.keys.backspace": "Backspace",
  "keyboard_shortcuts.keys.enter": "Enter",
  "keyboard_shortcuts.keys.esc": "Esc",
  "keyboard_shortcuts.keys.page_down": "Page Down",
  "keyboard_shortcuts.keys.page_up": "Page Up",
  "keyboard_shortcuts.legend": "показать эту справку",
  "keyboard_shortcuts.load_more": "фокус на кнопке «Загрузить ещё»",
  "keyboard_shortcuts.local": "перейти к локальной ленте",
  "keyboard_shortcuts.mention": "упомянуть автора поста",
  "keyboard_shortcuts.muted": "открыть список игнорируемых пользователей",
  "keyboard_shortcuts.my_profile": "перейти к своему профилю",
  "keyboard_shortcuts.notifications": "перейти к уведомлениям",
  "keyboard_shortcuts.open_media": "открыть медиа",
  "keyboard_shortcuts.pinned": "перейти к закреплённым постам",
  "keyboard_shortcuts.profile": "перейти к профилю автора",
  "keyboard_shortcuts.quote": "цитировать пост",
  "keyboard_shortcuts.reply": "ответить",
  "keyboard_shortcuts.requests": "перейти к запросам на подписку",
  "keyboard_shortcuts.search": "перейти к поиску",
  "keyboard_shortcuts.spoilers": "показать/скрыть поле предупреждения о содержании",
  "keyboard_shortcuts.start": "перейти к разделу «Добро пожаловать»",
  "keyboard_shortcuts.toggle_hidden": "показать/скрыть текст за предупреждением",
  "keyboard_shortcuts.toggle_sensitivity": "показать/скрыть медиа",
  "keyboard_shortcuts.toot": "начать писать новый пост",
  "keyboard_shortcuts.top": "перейти в начало списка",
  "keyboard_shortcuts.translate": "перевести пост",
  "keyboard_shortcuts.unfocus": "убрать фокус с поля ввода/поиска",
  "keyboard_shortcuts.up": "вверх по списку",
  "learn_more_link.got_it": "Понятно",
  "learn_more_link.learn_more": "Подробнее",
  "lightbox.close": "Закрыть",
  "lightbox.next": "Далее",
  "lightbox.previous": "Назад",
  "lightbox.zoom_in": "Масштаб до фактического размера",
  "lightbox.zoom_out": "Масштаб по размеру экрана",
  "limited_account_hint.action": "Всё равно показать",
  "limited_account_hint.title": "Этот профиль либо его сервер были скрыты модераторами сервера {domain}.",
  "link_preview.author": "Автор: {name}",
  "link_preview.more_from_author": "Автор: {name}",
  "link_preview.shares": "{count, plural, one {{counter} пост} few {{counter} поста} other {{counter} постов}}",
  "lists.add_member": "Добавить",
  "lists.add_to_list": "Добавить в список",
  "lists.add_to_lists": "Добавить {name} в списки",
  "lists.create": "Создать",
  "lists.create_a_list_to_organize": "Создайте новый список, чтобы упорядочить домашнюю ленту.",
  "lists.create_list": "Создать список",
  "lists.delete": "Удалить список",
  "lists.done": "Готово",
  "lists.edit": "Редактировать список",
  "lists.exclusive": "Скрывать пользователей в этом списке из домашней ленты",
  "lists.exclusive_hint": "Не показывать посты пользователей в этом списке в домашней ленте, чтобы не видеть их дважды.",
  "lists.find_users_to_add": "Воспользуйтесь поиском, чтобы добавить пользователей в список.",
  "lists.list_members_count": "{count, plural, one {# пользователь} few {# пользователя} other {# пользователей}}",
  "lists.list_name": "Название списка",
  "lists.new_list_name": "Новый список",
  "lists.no_lists_yet": "Вы ещё не создали ни одного списка.",
  "lists.no_members_yet": "В этом списке пока нет ни одного человека.",
  "lists.no_results_found": "Ничего не найдено.",
  "lists.remove_member": "Удалить",
  "lists.replies_policy.followed": "Все пользователи, на которых вы подписаны",
  "lists.replies_policy.list": "Другие пользователи в списке",
  "lists.replies_policy.none": "Никто",
  "lists.save": "Сохранить",
  "lists.search": "Поиск",
  "lists.show_replies_to": "Пользователи, ответы которым будут включены в список",
  "load_pending": "{count, plural, one {# новый элемент} few {# новых элемента} other {# новых элементов}}",
  "loading_indicator.label": "Загрузка…",
  "media_gallery.hide": "Скрыть",
  "moved_to_account_banner.text": "Ваша учётная запись {disabledAccount} в настоящее время отключена, потому что вы переехали на {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Скрывать уведомления",
  "mute_modal.hide_options": "Скрыть опции",
  "mute_modal.indefinite": "Бессрочно",
  "mute_modal.show_options": "Показать опции",
  "mute_modal.they_can_mention_and_follow": "Он сможет упоминать вас и подписаться на вас, но вы этого не увидите.",
  "mute_modal.they_wont_know": "Он не будет знать, что вы его игнорируете.",
  "mute_modal.title": "Игнорировать пользователя?",
  "mute_modal.you_wont_see_mentions": "Вы не будете видеть посты, упоминающие его.",
  "mute_modal.you_wont_see_posts": "Он по-прежнему сможет видеть ваши посты, но вы не будете видеть его посты.",
  "navigation_bar.about": "О проекте",
  "navigation_bar.account_settings": "Пароль и безопасность",
  "navigation_bar.administration": "Администрирование",
  "navigation_bar.advanced_interface": "Открыть в многоколоночном интерфейсе",
  "navigation_bar.automated_deletion": "Автоудаление постов",
  "navigation_bar.blocks": "Заблокированные пользователи",
  "navigation_bar.bookmarks": "Закладки",
  "navigation_bar.collections": "Подборки",
  "navigation_bar.direct": "Личные упоминания",
  "navigation_bar.domain_blocks": "Заблокированные домены",
  "navigation_bar.favourites": "Избранное",
  "navigation_bar.filters": "Игнорируемые слова",
  "navigation_bar.follow_requests": "Запросы на подписку",
  "navigation_bar.followed_tags": "Подписки на хештеги",
  "navigation_bar.follows_and_followers": "Подписки и подписчики",
  "navigation_bar.import_export": "Импорт и экспорт",
  "navigation_bar.lists": "Списки",
  "navigation_bar.live_feed_local": "Локальная лента",
  "navigation_bar.live_feed_public": "Глобальная лента",
  "navigation_bar.logout": "Выйти",
  "navigation_bar.main": "Главное меню",
  "navigation_bar.moderation": "Модерирование",
  "navigation_bar.more": "Ещё",
  "navigation_bar.mutes": "Игнорируемые пользователи",
  "navigation_bar.opened_in_classic_interface": "Посты, профили пользователей и некоторые другие страницы по умолчанию открываются в классическом веб-интерфейсе.",
  "navigation_bar.preferences": "Настройки",
  "navigation_bar.privacy_and_reach": "Приватность и видимость",
  "navigation_bar.search": "Поиск",
  "navigation_bar.search_trends": "Поиск / Актуальное",
  "navigation_panel.collapse_followed_tags": "Свернуть меню подписок на хештеги",
  "navigation_panel.collapse_lists": "Свернуть меню списков",
  "navigation_panel.expand_followed_tags": "Развернуть меню подписок на хештеги",
  "navigation_panel.expand_lists": "Развернуть меню списков",
  "not_signed_in_indicator.not_signed_in": "Эта страница доступна только авторизованным пользователям.",
  "notification.added_to_collection": "{name} добавил(а) вас в подборку",
  "notification.admin.report": "{name} пожаловался (-лась) на {target}",
  "notification.admin.report_account": "{name} пожаловался (-лась) на {count, plural, one {# пост} few {# поста} other {# постов}} пользователя {target}, выбрав категорию «{category}»",
  "notification.admin.report_account_other": "{name} пожаловался (-лась) на {count, plural, one {# пост} few {# поста} other {# постов}} пользователя {target}",
  "notification.admin.report_statuses": "{name} пожаловался (-лась) на {target}, выбрав категорию «{category}»",
  "notification.admin.report_statuses_other": "{name} пожаловался (-лась) на {target}",
  "notification.admin.sign_up": "{name} зарегистрировался (-лась) на сервере",
  "notification.admin.sign_up.name_and_others": "{name} и ещё {count, plural, one {# пользователь} few {# пользователя} other {# пользователей}} зарегистрировались на сервере",
  "notification.annual_report.message": "#Wrapstodon за {year} год ждёт вас! Откройте для себя итоги и памятные моменты этого года в Mastodon.",
  "notification.annual_report.view": "Перейти к #Wrapstodon",
  "notification.favourite": "{name} добавил(а) ваш пост в избранное",
  "notification.favourite.name_and_others_with_link": "{name} и ещё <a>{count, plural, one {# пользователь} few {# пользователя} other {# пользователей}}</a> добавили ваш пост в избранное",
  "notification.favourite_pm": "{name} добавил(а) ваше личное упоминание в избранное",
  "notification.favourite_pm.name_and_others_with_link": "{name} и ещё <a>{count, plural, one {# пользователь} few {# пользователя} other {# пользователей}}</a> добавили ваше личное упоминание в избранное",
  "notification.follow": "{name} подписался (-лась) на вас",
  "notification.follow.name_and_others": "{name} и ещё <a>{count, plural, one {# пользователь} few {# пользователя} other {# пользователей}}</a> подписались на вас",
  "notification.follow_request": "{name} отправил(а) вам запрос на подписку",
  "notification.follow_request.name_and_others": "{name} и ещё {count, plural, one {# пользователь} few {# пользователя} other {# пользователей}} подписались на вас",
  "notification.label.mention": "Упоминание",
  "notification.label.private_mention": "Личное упоминание",
  "notification.label.private_reply": "Приватный ответ",
  "notification.label.quote": "{name} процитировал(а) ваш пост",
  "notification.label.reply": "Ответ",
  "notification.mention": "Упоминание",
  "notification.mentioned_you": "{name} упомянул(а) вас",
  "notification.moderation-warning.learn_more": "Узнать больше",
  "notification.moderation_warning": "Модераторы вынесли вам предупреждение",
  "notification.moderation_warning.action_delete_statuses": "Некоторые ваши посты были удалены.",
  "notification.moderation_warning.action_disable": "Ваша учётная запись была отключена.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Некоторые ваши посты были отмечены как содержимое деликатного характера.",
  "notification.moderation_warning.action_none": "Модераторы вынесли вам предупреждение.",
  "notification.moderation_warning.action_sensitive": "С этого момента все ваши посты будут отмечены как содержимое деликатного характера.",
  "notification.moderation_warning.action_silence": "Ваша учётная запись была ограничена.",
  "notification.moderation_warning.action_suspend": "Ваша учётная запись была заблокирована.",
  "notification.own_poll": "Ваш опрос завершился",
  "notification.poll": "Опрос, в котором вы приняли участие, завершился",
  "notification.quoted_update": "{name} отредактировал(а) процитированный вами пост",
  "notification.reblog": "{name} продвинул(а) ваш пост",
  "notification.reblog.name_and_others_with_link": "{name} и ещё <a>{count, plural, one {# пользователь} few {# пользователя} other {# пользователей}}</a> продвинули ваш пост",
  "notification.relationships_severance_event": "Разорвана связь с {name}",
  "notification.relationships_severance_event.account_suspension": "Администратор сервера {from} заблокировал сервер {target}, поэтому вы больше не сможете получать обновления от людей с этого сервера и взаимодействовать с ними.",
  "notification.relationships_severance_event.domain_block": "Администратор сервера {from} заблокировал сервер {target}, где размещены учётные записи {followersCount} ваших подписчиков и {followingCount, plural, one {# пользователя, на которого вы подписаны} other {# пользователей, на которых вы подписаны}}.",
  "notification.relationships_severance_event.learn_more": "Узнать больше",
  "notification.relationships_severance_event.user_domain_block": "Вы заблокировали сервер {target}, где размещены учётные записи {followersCount} ваших подписчиков и {followingCount, plural, one {# пользователя, на которого вы подписаны} other {# пользователей, на которых вы подписаны}}.",
  "notification.status": "{name} опубликовал(а) новый пост",
  "notification.update": "{name} отредактировал(а) пост",
  "notification_requests.accept": "Принять",
  "notification_requests.accept_multiple": "{count, plural, one {Принять # запрос…} few {Принять # запроса…} other {Принять # запросов…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, other {Принять запросы}}",
  "notification_requests.confirm_accept_multiple.message": "Вы собираетесь принять {count, plural, one {# запрос на показ уведомлений} few {# запроса на показ уведомлений} other {# запросов на показ уведомлений}}. Продолжить?",
  "notification_requests.confirm_accept_multiple.title": "Принять запросы на уведомления?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, other {Отклонить запросы}}",
  "notification_requests.confirm_dismiss_multiple.message": "Вы собираетесь отклонить {count, plural, one {# запрос на показ уведомлений} few {# запроса на показ уведомлений} other {# запросов на показ уведомлений}}. Вы не сможете просмотреть {count, plural, other {их}} потом. Продолжить?",
  "notification_requests.confirm_dismiss_multiple.title": "Отклонить запросы на уведомления?",
  "notification_requests.dismiss": "Отклонить",
  "notification_requests.dismiss_multiple": "{count, plural, one {Отклонить # запрос…} few {Отклонить # запроса…} other {Отклонить # запросов…}}",
  "notification_requests.edit_selection": "Изменить",
  "notification_requests.exit_selection": "Готово",
  "notification_requests.explainer_for_limited_account": "Эта учётная запись ограничена модератором, поэтому уведомления от неё были отфильтрованы.",
  "notification_requests.explainer_for_limited_remote_account": "Эта учётная запись или её сервер ограничены модератором, поэтому уведомления от неё были отфильтрованы.",
  "notification_requests.maximize": "Развернуть",
  "notification_requests.minimize_banner": "Свернуть панель отфильтрованных уведомлений в значок",
  "notification_requests.notifications_from": "Уведомления от {name}",
  "notification_requests.title": "Отфильтрованные уведомления",
  "notification_requests.view": "Просмотр уведомлений",
  "notifications.clear": "Очистить уведомления",
  "notifications.clear_confirmation": "Вы уверены, что хотите очистить все уведомления?",
  "notifications.clear_title": "Очистить уведомления?",
  "notifications.column_settings.admin.report": "Новые жалобы:",
  "notifications.column_settings.admin.sign_up": "Новые регистрации:",
  "notifications.column_settings.alert": "Уведомления на рабочем столе",
  "notifications.column_settings.collections": "Подборки:",
  "notifications.column_settings.favourite": "Ваш пост добавили в избранное:",
  "notifications.column_settings.filter_bar.advanced": "Показывать все категории",
  "notifications.column_settings.filter_bar.category": "Панель быстрых фильтров",
  "notifications.column_settings.follow": "У вас новый подписчик:",
  "notifications.column_settings.follow_request": "Новые запросы на подписку:",
  "notifications.column_settings.group": "Группировать",
  "notifications.column_settings.mention": "Вас упомянули в посте:",
  "notifications.column_settings.poll": "Опрос, в котором вы приняли участие, завершился:",
  "notifications.column_settings.push": "Push-уведомления",
  "notifications.column_settings.quote": "Ваш пост процитировали:",
  "notifications.column_settings.reblog": "Ваш пост продвинули:",
  "notifications.column_settings.show": "Отображать в списке",
  "notifications.column_settings.sound": "Проигрывать звук",
  "notifications.column_settings.status": "Новые посты:",
  "notifications.column_settings.unread_notifications.category": "Непрочитанные уведомления",
  "notifications.column_settings.unread_notifications.highlight": "Выделять непрочитанные уведомления",
  "notifications.column_settings.update": "Пост был отредактирован:",
  "notifications.filter.all": "Все",
  "notifications.filter.boosts": "Продвижения",
  "notifications.filter.collections": "Подборки",
  "notifications.filter.favourites": "Избранное",
  "notifications.filter.follows": "Новые подписчики",
  "notifications.filter.mentions": "Упоминания",
  "notifications.filter.polls": "Результаты опросов",
  "notifications.filter.statuses": "Обновления от людей, на которых вы подписаны",
  "notifications.grant_permission": "Предоставить разрешение.",
  "notifications.group": "{count, plural, one {# уведомление}, few {# уведомления}, other {# уведомлений}}",
  "notifications.mark_as_read": "Отметить все уведомления прочитанными",
  "notifications.permission_denied": "Уведомления на рабочем столе недоступны, так как вы запретили их отправку в браузере",
  "notifications.permission_denied_alert": "Не удалось включить уведомления на рабочем столе, так как вы отклонили запрос разрешения на их отправку в браузере",
  "notifications.permission_required": "Чтобы включить уведомления на рабочем столе, необходимо разрешить их отправку в браузере.",
  "notifications.policy.accept": "Принимать",
  "notifications.policy.accept_hint": "Показывать в уведомлениях",
  "notifications.policy.drop": "Игнорировать",
  "notifications.policy.drop_hint": "Отправлять в пустоту, чтобы никогда больше не увидеть",
  "notifications.policy.filter": "Фильтровать",
  "notifications.policy.filter_bots_hint": "Отмеченные как выполняющие автоматизированные действия",
  "notifications.policy.filter_bots_title": "Учётные записи ботов",
  "notifications.policy.filter_hint": "Отправлять в раздел отфильтрованных уведомлений",
  "notifications.policy.filter_limited_accounts_hint": "Ограниченные модераторами сервера",
  "notifications.policy.filter_limited_accounts_title": "Модерируемые учётные записи",
  "notifications.policy.filter_new_accounts.hint": "Созданные в течение {days, plural, one {последнего # дня} other {последних # дней}}",
  "notifications.policy.filter_new_accounts_title": "Новые учётные записи",
  "notifications.policy.filter_not_followers_hint": "Включая людей, которые подписаны на вас меньше чем {days, plural, one {# день} few {# дня} other {# дней}}",
  "notifications.policy.filter_not_followers_title": "Люди, не подписанные на вас",
  "notifications.policy.filter_not_following_hint": "Пока вы не одобрите их вручную",
  "notifications.policy.filter_not_following_title": "Люди, на которых вы не подписаны",
  "notifications.policy.filter_private_mentions_hint": "Не фильтруются ответы на ваши собственные упоминания, а также личные упоминания от пользователей, на которых вы подписаны",
  "notifications.policy.filter_private_mentions_title": "Нежелательные личные упоминания",
  "notifications.policy.title": "Управление уведомлениями",
  "notifications_permission_banner.enable": "Включить уведомления",
  "notifications_permission_banner.how_to_control": "Чтобы получать уведомления, даже когда Mastodon закрыт, включите уведомления на рабочем столе. После того как вы их включите, вы сможете тонко настроить виды взаимодействий, о которых вы будете оповещены через уведомления на рабочем столе, нажав на кнопку {icon} выше.",
  "notifications_permission_banner.title": "Будьте в курсе происходящего",
  "onboarding.follows.back": "Назад",
  "onboarding.follows.empty": "К сожалению, на данный момент предложения отсутствуют. Чтобы найти, на кого подписаться, вы можете просматривать раздел «Актуальное» или воспользоваться поиском.",
  "onboarding.follows.next": "Следующий шаг: Создайте профиль",
  "onboarding.follows.search": "Поиск",
  "onboarding.follows.title": "Начните подписываться на людей",
  "onboarding.profile.discoverable": "Сделать мой профиль доступным для поиска",
  "onboarding.profile.discoverable_hint": "Если вы согласитесь сделать профиль доступным для поиска в Mastodon, ваши посты могут быть показаны в результатах поиска и в разделе «Актуальное», а ваш профиль может быть предложен людям со схожими интересами.",
  "onboarding.profile.display_name": "Отображаемое имя",
  "onboarding.profile.display_name_hint": "Ваше полное имя или псевдоним…",
  "onboarding.profile.finish": "Готово",
  "onboarding.profile.note": "О себе",
  "onboarding.profile.note_hint": "Вы можете @упоминать других людей, а также использовать #хештеги…",
  "onboarding.profile.title": "Создайте свой профиль",
  "onboarding.profile.upload_avatar": "Загрузить фото профиля",
  "onboarding.profile.upload_header": "Загрузить обложку профиля",
  "password_confirmation.exceeds_maxlength": "Подтверждение пароля превышает максимально допустимую длину пароля",
  "password_confirmation.mismatching": "Введённые пароли не совпадают",
  "picture_in_picture.restore": "Вернуть обратно",
  "poll.closed": "Завершён",
  "poll.refresh": "Обновить",
  "poll.reveal": "Результаты",
  "poll.total_people": "{count, plural, one {# человек} few {# человека} many {# человек} other {# человек}}",
  "poll.total_votes": "{count, plural, one {# голос} few {# голоса} many {# голосов} other {# голосов}}",
  "poll.vote": "Голосовать",
  "poll.voted": "Вы проголосовали за этот вариант",
  "poll.votes": "{votes, plural, one {# голос} many {# голосов} other {# голоса}}",
  "poll_button.add_poll": "Добавить опрос",
  "poll_button.remove_poll": "Удалить опрос",
  "privacy.change": "Изменить видимость поста",
  "privacy.direct.long": "Всем, кто был упомянут в посте",
  "privacy.direct.short": "Личное упоминание",
  "privacy.private.long": "Только для ваших подписчиков",
  "privacy.private.short": "Для подписчиков",
  "privacy.public.long": "Для кого угодно в интернете",
  "privacy.public.short": "Публичный",
  "privacy.quote.anyone": "{visibility}, с возможностью цитирования",
  "privacy.quote.disabled": "{visibility}, без возможности цитирования",
  "privacy.quote.limited": "{visibility}, с ограничениями цитирования",
  "privacy.unlisted.additional": "Похоже на «Публичный» за исключением того, что пост не появится ни в живых лентах, ни в лентах хештегов, ни в разделе «Актуальное», ни в поиске Mastodon, даже если вы разрешили поиск по своим постам в настройках профиля.",
  "privacy.unlisted.long": "Не показывать в результатах поиска Mastodon, трендах и публичных лентах",
  "privacy.unlisted.short": "Тихий публичный",
  "privacy_policy.last_updated": "Последнее обновление: {date}",
  "privacy_policy.title": "Политика конфиденциальности",
  "quote_error.edit": "Нельзя добавить цитирование к уже опубликованному посту.",
  "quote_error.poll": "Цитирование не позволяется, если к посту добавлен опрос.",
  "quote_error.private_mentions": "Цитирование в личных упоминаниях не позволяется.",
  "quote_error.quote": "Нельзя добавить больше одного цитирования.",
  "quote_error.unauthorized": "Вы не можете цитировать этот пост.",
  "quote_error.upload": "Цитирование не позволяется, если к посту прикреплены медиавложения.",
  "recommended": "Рекомендуется",
  "refresh": "Обновить",
  "regeneration_indicator.please_stand_by": "Пожалуйста, подождите.",
  "regeneration_indicator.preparing_your_home_feed": "Готовим вашу ленту…",
  "relative_time.days": "{number} д.",
  "relative_time.full.days": "{number, plural, one {# день} many {# дней} other {# дня}} назад",
  "relative_time.full.hours": "{number, plural, one {# час} many {# часов} other {# часа}} назад",
  "relative_time.full.just_now": "только что",
  "relative_time.full.minutes": "{number, plural, one {# минуту} many {# минут} other {# минуты}} назад",
  "relative_time.full.seconds": "{number, plural, one {# секунду} many {# секунд} other {# секунды}} назад",
  "relative_time.hours": "{number} ч.",
  "relative_time.just_now": "только что",
  "relative_time.minutes": "{number} мин.",
  "relative_time.seconds": "{number} с.",
  "relative_time.today": "сегодня",
  "remove_quote_hint.button_label": "Понятно",
  "remove_quote_hint.message": "Вы можете сделать это из {icon} меню поста.",
  "remove_quote_hint.title": "Хотите убрать цитирование вашего поста?",
  "reply_indicator.attachments": "{count, plural, one {# вложение} few {# вложения} other {# вложений}}",
  "reply_indicator.cancel": "Отмена",
  "reply_indicator.poll": "Опрос",
  "report.block": "Заблокировать",
  "report.block_explanation": "Вы не будете видеть посты этого пользователя. Этот пользователь не сможет ни видеть ваши посты, ни подписаться на вас. Пользователь будет знать, что вы его блокируете.",
  "report.categories.legal": "Нарушение закона",
  "report.categories.other": "Другое",
  "report.categories.spam": "Спам",
  "report.categories.violation": "Содержимое нарушает одно или несколько правил сервера",
  "report.category.subtitle": "Выберите наиболее подходящий вариант",
  "report.category.title_account": "Расскажите нам, что не так с этим профилем",
  "report.category.title_collection": "Расскажите нам, что не так с этой подборкой",
  "report.category.title_status": "Расскажите нам, что не так с этим постом",
  "report.close": "Готово",
  "report.comment.title": "Есть ли ещё подробности, о которых нам стоит знать?",
  "report.forward": "Переслать в {target}",
  "report.forward_hint": "Эта учётная запись расположена на другом сервере. Отправить туда обезличенную копию вашей жалобы?",
  "report.mute": "Игнорировать",
  "report.mute_explanation": "Вы не будете видеть посты этого пользователя. Этот пользователь по-прежнему сможет видеть ваши посты и не будет знать, что вы его игнорируете.",
  "report.next": "Далее",
  "report.placeholder": "Дополнительные комментарии",
  "report.reasons.dislike": "Мне это не нравится",
  "report.reasons.dislike_description": "Выберите, если не хотели бы видеть подобное",
  "report.reasons.legal": "Это незаконно",
  "report.reasons.legal_description": "Выберите, если считаете, что подобное нарушает закон вашей страны или той страны, в юрисдикции которой находится сервер",
  "report.reasons.other": "Другое",
  "report.reasons.other_description": "Проблема не соответствует ни одной категории",
  "report.reasons.spam": "Это спам",
  "report.reasons.spam_description": "Вредоносные ссылки, фальшивая активность или повторяющиеся однообразные ответы",
  "report.reasons.violation": "Нарушаются правила сервера",
  "report.reasons.violation_description": "Выберите, если знаете, что подобное нарушает определённые правила",
  "report.rules.subtitle": "Выберите все подходящие варианты",
  "report.rules.title": "Какие правила нарушены?",
  "report.statuses.subtitle": "Отметьте все подходящие посты",
  "report.statuses.title": "Выберите посты, которые относятся к вашей жалобе.",
  "report.submission_error": "Не удалось отправить жалобу",
  "report.submission_error_details": "Проверьте свое подключение к сети и повторите попытку позже.",
  "report.submit": "Отправить",
  "report.target": "Жалоба на {target}",
  "report.thanks.take_action": "Вот несколько средств, с помощью которых можно контролировать, что вы видите в Mastodon:",
  "report.thanks.take_action_actionable": "Пока мы её рассматриваем, вы можете самостоятельно принять меры против @{name}:",
  "report.thanks.title": "Не хотите видеть это?",
  "report.thanks.title_actionable": "Спасибо, что сообщили о проблеме, мы рассмотрим вашу жалобу.",
  "report.unfollow": "Отписаться от @{name}",
  "report.unfollow_explanation": "Вы подписаны на этого пользователя. Отпишитесь от пользователя, чтобы перестать видеть посты этого человека в домашней ленте.",
  "report_notification.attached_statuses": "{count, plural, one {{count} пост прикреплён} few {{count} поста прикреплено} other {{count} постов прикреплено}}",
  "report_notification.categories.legal": "Нарушение закона",
  "report_notification.categories.legal_sentence": "Нарушение закона",
  "report_notification.categories.other": "Другое",
  "report_notification.categories.other_sentence": "Другое",
  "report_notification.categories.spam": "Спам",
  "report_notification.categories.spam_sentence": "Спам",
  "report_notification.categories.violation": "Нарушение правил",
  "report_notification.categories.violation_sentence": "Нарушение правил",
  "report_notification.open": "Перейти к жалобе",
  "search.clear": "Очистить поисковый запрос",
  "search.no_recent_searches": "Недавние запросы отсутствуют",
  "search.placeholder": "Поиск",
  "search.quick_action.account_search": "Профили, соответствующие {x}",
  "search.quick_action.go_to_account": "Перейти к профилю {x}",
  "search.quick_action.go_to_hashtag": "Перейти к хештегу {x}",
  "search.quick_action.open_url": "Открыть URL в Mastodon",
  "search.quick_action.status_search": "Посты, соответствующие {x}",
  "search.search_or_paste": "Поиск (или вставьте URL)",
  "search_popout.full_text_search_disabled_message": "Недоступно на сервере {domain}.",
  "search_popout.full_text_search_logged_out_message": "Доступно только авторизованным пользователям.",
  "search_popout.language_code": "ISO-код языка",
  "search_popout.options": "Параметры поиска",
  "search_popout.quick_actions": "Быстрые действия",
  "search_popout.recent": "Недавние запросы",
  "search_popout.specific_date": "дата",
  "search_popout.user": "пользователь",
  "search_results.accounts": "Профили",
  "search_results.all": "Все",
  "search_results.collections": "Подборки",
  "search_results.hashtags": "Хештеги",
  "search_results.no_results": "Ничего не найдено.",
  "search_results.no_search_yet": "Попробуйте поискать посты, профили или хештеги.",
  "search_results.see_all": "Показать все",
  "search_results.statuses": "Посты",
  "search_results.title": "Поиск \"{q}\"",
  "server_banner.about_active_users": "Число зарегистрированных пользователей, заходивших на этот сервер за последние 30 дней (MAU-метрика)",
  "server_banner.active_users": "активные пользователи",
  "server_banner.administered_by": "Управляется:",
  "server_banner.is_one_of_many": "{domain} — это один из многих независимых серверов Mastodon, которые вы можете использовать, чтобы присоединиться к сети Fediverse.",
  "server_banner.more_about_this_server": "Больше об этом сервере",
  "server_banner.server_stats": "Статистика сервера:",
  "sign_in_banner.create_account": "Зарегистрироваться",
  "sign_in_banner.follow_anyone": "Подписывайтесь на кого угодно в федивёрсе и читайте ленту в хронологическом порядке. Никаких алгоритмов, рекламы и кликбейта.",
  "sign_in_banner.mastodon_is": "Mastodon — лучший способ быть в курсе всего происходящего.",
  "sign_in_banner.sign_in": "Войти",
  "sign_in_banner.sso_redirect": "Вход/Регистрация",
  "skip_links.skip_to_content": "Перейти к основному содержимому",
  "status.admin_account": "Открыть интерфейс модератора для @{name}",
  "status.admin_domain": "Открыть интерфейс модератора для {domain}",
  "status.admin_status": "Открыть этот пост в интерфейсе модератора",
  "status.all_disabled": "Нельзя продвинуть или процитировать",
  "status.block": "Заблокировать @{name}",
  "status.bookmark": "Добавить в закладки",
  "status.cancel_reblog_private": "Отменить продвижение",
  "status.cannot_quote": "Вы не можете процитировать этот пост",
  "status.cannot_reblog": "Этот пост не может быть продвинут",
  "status.contains_quote": "Цитирует другой пост",
  "status.context.loading": "Загрузка ответов",
  "status.context.loading_error": "Не удалось загрузить новые ответы",
  "status.context.loading_success": "Загружены новые ответы",
  "status.context.more_replies_found": "Найдены другие ответы",
  "status.context.retry": "Повторить",
  "status.context.show": "Показать",
  "status.continued_thread": "Продолжение предыдущего поста",
  "status.copy": "Скопировать ссылку на пост",
  "status.delete": "Удалить",
  "status.delete.success": "Пост удалён",
  "status.detailed_status": "Подробный просмотр обсуждения",
  "status.direct": "Упомянуть @{name} лично",
  "status.direct_indicator": "Личное упоминание",
  "status.edit": "Редактировать",
  "status.edited": "Последнее изменение: {date}",
  "status.edited_x_times": "{count, plural, one {{count} изменение} many {{count} изменений} other {{count} изменения}}",
  "status.embed": "Встроить на свой сайт",
  "status.favourite": "Добавить в избранное",
  "status.favourites_count": "{count, plural, one {{counter} звёздочка} few {{counter} звёздочки} other {{counter} звёздочек}}",
  "status.filter": "Фильтровать этот пост",
  "status.history.created": "{name} создал(а) пост {date}",
  "status.history.edited": "{name} отредактировал(а) пост {date}",
  "status.load_more": "Загрузить ещё",
  "status.media.open": "Нажмите, чтобы открыть.",
  "status.media.show": "Нажмите, чтобы показать",
  "status.media_hidden": "Медиа скрыты",
  "status.mention": "Упомянуть @{name}",
  "status.more": "Ещё",
  "status.mute": "Игнорировать @{name}",
  "status.mute_conversation": "Игнорировать обсуждение",
  "status.open": "Открыть пост",
  "status.pin": "Закрепить в профиле",
  "status.quote": "Цитировать",
  "status.quote.cancel": "Отменить цитирование",
  "status.quote_error.blocked_account_hint.title": "Этот пост был скрыт, поскольку вы заблокировали @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Этот пост был скрыт, поскольку вы заблокировали сервер {domain}.",
  "status.quote_error.filtered": "Скрыто одним из ваших фильтров",
  "status.quote_error.limited_account_hint.action": "Всё равно показать",
  "status.quote_error.limited_account_hint.title": "Этот профиль был скрыт модераторами сервера {domain}.",
  "status.quote_error.muted_account_hint.title": "Этот пост был скрыт, поскольку вы игнорируете @{name}.",
  "status.quote_error.not_available": "Пост недоступен",
  "status.quote_error.pending_approval": "Пост ожидает подтверждения",
  "status.quote_error.pending_approval_popout.body": "Mastodon позволяет каждому контролировать, кто может цитировать его посты. Этот пост временно недоступен, пока мы запрашиваем подтверждение того, что его цитирование одобрено автором.",
  "status.quote_error.revoked": "Пост удалён автором",
  "status.quote_followers_only": "Только подписчики могут цитировать этот пост",
  "status.quote_manual_review": "Автор должен одобрить запрос вручную",
  "status.quote_noun": "Цитата",
  "status.quote_policy_change": "Изменить настройки цитирования",
  "status.quote_post_author": "Процитировал(а) пост @{name}",
  "status.quote_private": "Приватные посты не могут быть процитированы",
  "status.quotes.empty": "Никто еще не процитировал этот пост. Все цитирования этого поста будут показаны здесь.",
  "status.quotes.local_other_disclaimer": "Цитирования, не одобренные автором, не будут показаны.",
  "status.quotes.remote_other_disclaimer": "Только цитирования с сервера {domain} гарантированно показаны здесь. Цитирования, не одобренные автором, не будут показаны.",
  "status.quotes_count": "{count, plural, one {{counter} цитирование} few {{counter} цитирования} other {{counter} цитирований}}",
  "status.read_more": "Читать далее",
  "status.reblog": "Продвинуть",
  "status.reblog_or_quote": "Продвинуть или процитировать",
  "status.reblog_private": "Продвинуть пост для своих подписчиков",
  "status.reblogged_by": "{name} продвинул(а)",
  "status.reblogs.empty": "Никто ещё не продвинул этот пост. Все пользователи, которые продвинут этот пост, будут показаны здесь.",
  "status.reblogs_count": "{count, plural, one {{counter} продвижение} few {{counter} продвижения} other {{counter} продвижений}}",
  "status.redraft": "Удалить и исправить",
  "status.remove_bookmark": "Убрать из закладок",
  "status.remove_favourite": "Убрать из избранного",
  "status.remove_quote": "Удалить",
  "status.replied_in_thread": "Ответил(а) в обсуждении",
  "status.replied_to": "Ответил(а) {name}",
  "status.reply": "Ответить",
  "status.replyAll": "Ответить в обсуждении",
  "status.report": "Пожаловаться на @{name}",
  "status.request_quote": "Запросить цитирование",
  "status.revoke_quote": "Убрать мой пост из поста @{name}",
  "status.sensitive_warning": "Медиа деликатного характера",
  "status.share": "Поделиться",
  "status.show_less_all": "Свернуть все предупреждения о содержании в ветке",
  "status.show_more_all": "Развернуть все предупреждения о содержании в ветке",
  "status.show_original": "Показать оригинал",
  "status.title.with_attachments": "{user} опубликовал(а) {attachmentCount, plural, one {{attachmentCount} вложение} few {{attachmentCount} вложения} other {{attachmentCount} вложений}}",
  "status.translate": "Перевод",
  "status.translated_from_with": "Переведено с {lang} с помощью {provider}",
  "status.uncached_media_warning": "Предварительный просмотр недоступен",
  "status.unmute_conversation": "Не игнорировать обсуждение",
  "status.unpin": "Открепить от профиля",
  "subscribed_languages.lead": "Посты лишь на выбранных языках будут появляться в вашей домашней ленте и списках после изменения. Снимите выбор, чтобы получать посты на всех языках.",
  "subscribed_languages.save": "Сохранить изменения",
  "subscribed_languages.target": "Изменить языки подписки для {target}",
  "tabs_bar.home": "Главная",
  "tabs_bar.menu": "Меню",
  "tabs_bar.notifications": "Уведомления",
  "tabs_bar.publish": "Создать пост",
  "tabs_bar.search": "Поиск",
  "tag.remove": "Удалить",
  "terms_of_service.effective_as_of": "Действует с {date}",
  "terms_of_service.title": "Пользовательское соглашение",
  "terms_of_service.upcoming_changes_on": "Изменения вступают в силу с {date}",
  "time_remaining.days": "{number, plural, one {остался # день} few {осталось # дня} many {осталось # дней} other {осталось # дней}}",
  "time_remaining.hours": "{number, plural, one {остался # час} few {осталось # часа} many {осталось # часов} other {осталось # часов}}",
  "time_remaining.minutes": "{number, plural, one {осталась # минута} few {осталось # минуты} many {осталось # минут} other {осталось # минут}}",
  "time_remaining.moments": "остались считанные мгновения",
  "time_remaining.seconds": "{number, plural, one {# секунда} many {# секунд} other {# секунды}}",
  "trends.counter_by_accounts": "{count, plural, few {{counter} человека} other {{counter} человек}} за {days, plural, one {последний {days} день} few {последние {days} дня} other {последние {days} дней}}",
  "trends.trending_now": "Самое актуальное",
  "ui.beforeunload": "Ваш черновик будет утрачен, если вы покинете Mastodon.",
  "units.short.billion": "{count} млрд",
  "units.short.million": "{count} млн",
  "units.short.thousand": "{count} тыс.",
  "upload_area.title": "Перетащите сюда, чтобы загрузить",
  "upload_button.label": "Прикрепить фото, видео или аудио",
  "upload_error.limit": "Превышено максимальное количество вложений.",
  "upload_error.poll": "К опросам нельзя прикреплять файлы.",
  "upload_error.quote": "К цитированиям нельзя прикреплять файлы.",
  "upload_form.drag_and_drop.instructions": "Чтобы выбрать вложение, нажмите \"Пробел\" (Space) или \"Ввод\" (Enter). Используйте клавиши со стрелками, чтобы передвинуть вложение в любом направлении. Нажмите \"Пробел\" (Space) или \"Ввод\" (Enter) ещё раз, чтобы переместить вложение на новое место, либо нажмите кнопку \"Выйти\" (Escape) для отмены перемещения.",
  "upload_form.drag_and_drop.on_drag_cancel": "Перемещение отменено. Вложение {item} было оставлено на прежнем месте.",
  "upload_form.drag_and_drop.on_drag_end": "Вложение {item} было перемещено.",
  "upload_form.drag_and_drop.on_drag_over": "Вложение {item} было передвинуто.",
  "upload_form.drag_and_drop.on_drag_start": "Выбрано вложение {item}.",
  "upload_form.edit": "Редактировать",
  "upload_progress.label": "Загрузка...",
  "upload_progress.processing": "Обработка…",
  "username.taken": "Это имя пользователя уже занято. Выберите другое",
  "video.close": "Закрыть видео",
  "video.download": "Скачать файл",
  "video.exit_fullscreen": "Покинуть полноэкранный режим",
  "video.expand": "Развернуть видео",
  "video.fullscreen": "Полноэкранный режим",
  "video.hide": "Скрыть видео",
  "video.mute": "Выключить звук",
  "video.pause": "Пауза",
  "video.play": "Пуск",
  "video.skip_backward": "Перемотка назад",
  "video.skip_forward": "Перемотка вперёд",
  "video.unmute": "Включить звук",
  "video.volume_down": "Громкость уменьшена",
  "video.volume_up": "Громкость увеличена",
  "visibility_modal.button_title": "Настроить видимость",
  "visibility_modal.direct_quote_warning.text": "Если вы сохраните эти настройки, добавленное цитирование будет преобразовано в ссылку.",
  "visibility_modal.direct_quote_warning.title": "Нельзя добавить цитирование к личным упоминаниям",
  "visibility_modal.header": "Видимость и взаимодействие",
  "visibility_modal.helper.direct_quoting": "Посты, созданные в Mastodon как личные упоминания, не могут быть процитированы другими пользователями.",
  "visibility_modal.helper.privacy_editing": "Видимость поста невозможно изменить после публикации.",
  "visibility_modal.helper.privacy_private_self_quote": "Посты, которые цитируют ваши приватные посты, не могут быть публичными.",
  "visibility_modal.helper.private_quoting": "Посты, созданные в Mastodon с видимостью только для подписчиков, не могут быть процитированы другими пользователями.",
  "visibility_modal.helper.unlisted_quoting": "Если кто-нибудь процитирует вас, его пост тоже будет скрыт из алгоритмических лент.",
  "visibility_modal.instructions": "Определите, кто сможет взаимодействовать с этим постом. Чтобы применить настройки ко всем будущим постам, перейдите в <link>Настройки → Предустановки для новых постов</link>.",
  "visibility_modal.privacy_label": "Видимость",
  "visibility_modal.quote_followers": "Только подписчики",
  "visibility_modal.quote_label": "Кто может цитировать вас",
  "visibility_modal.quote_nobody": "Только я",
  "visibility_modal.quote_public": "Кто угодно",
  "visibility_modal.save": "Сохранить"
}
